import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { fetchBaseQuery as e, createApi as t } from "@reduxjs/toolkit/query/react";
import { v4 as r } from "uuid";
import i from "moment";
import s from "react-xml-parser";
import a from "@arcgis/core/geometry/Polygon";
import n from "@arcgis/core/geometry/SpatialReference";
import o from "@arcgis/core/Graphic";
import u from "@arcgis/core/tasks/Locator";
import * as l from "@arcgis/core/geometry/support/webMercatorUtils";
import * as d from "@arcgis/core/geometry/support/jsonUtils";
import * as p from "@arcgis/core/geometry/projection";
import { arcgisToGeoJSON as c, geojsonToArcGIS as m } from "@terraformer/arcgis";
import { e as y, f as g } from "../index.js";
import G from "ajv";
import * as R from "ajv/lib/refs/json-schema-draft-04.json";
import { CognitoUserPool as E } from "amazon-cognito-identity-js";
import { Decimal as S } from "decimal.js";

var get = function get() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (e) try {
    return localStorage.getItem(e);
  } catch (t) {
    console.error("localStorage helper error fetching localStorage for ".concat(e));
  }
  return null;
},
    T = Object.freeze({
  __proto__: null,
  GRID_MODAL_PAGE_SIZE: "gridModalPageSize",
  GRID_FULL_PAGE_SIZE: "gridFullPageSize",
  BASE_MAP: "basemap",
  USERNAME: "username",
  REMEMBER_ME: "rememberMe",
  COMPANY_GUID: "companyGuid",
  COGNITO_CONFIG: "cognitoConfig",
  IOT_CONFIG: "iotConfig",
  USER_GUID: "userGuid",
  get: get,
  set: function set() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (e) try {
      localStorage.setItem(e, t);
    } catch (r) {
      console.error("localStorage helper error setting localStorage for ".concat(e));
    }
  },
  remove: function remove() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (e) try {
      localStorage.removeItem(e);
    } catch (t) {
      console.error("localStorage helper error removing ".concat(e));
    }
  },
  getStoredPageSize: function getStoredPageSize() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return e ? get("gridModalPageSize") || "10" : get("gridFullPageSize") || "50";
  }
}),
    A = l.webMercatorToGeographic,
    _ = l.geographicToWebMercator,
    geometryFromGeoJson = function geometryFromGeoJson(e, t) {
  var r = m(e),
      i = d.fromJSON(r);
  return i && (null == t ? void 0 : t.isWebMercator) ? _(i) : i && !(null == t ? void 0 : t.isGeographic) ? p.project(i, t) : i;
},
    toGraphic = function toGraphic(e, t, r, i) {
  return new o({
    geometry: e[t],
    attributes: Object.getOwnPropertyNames(e).reduce(function (s, a) {
      if (a !== t && !i.includes(a)) {
        var _t2 = a;
        s[r(a)] = e[_t2];
      }

      return s;
    }, {})
  }).clone();
},
    L = {
  config: y,
  extentToQueryParameter: function extentToQueryParameter(e) {
    var t = c(e),
        r = JSON.stringify(t);
    return btoa(r);
  },
  findAddress: function findAddress(e, t) {
    var r = new u({
      url: y.geocode.url
    });
    return r.outSpatialReference = t, r.addressToLocations({
      address: _defineProperty({}, y.geocode.addressParam, e)
    });
  },
  geoJsonFromGeometry: function geoJsonFromGeometry(e, t) {
    var r = d.fromJSON(e);
    return r && t && (r.spatialReference = t), c(r);
  },
  geometryFromEsriJson: function geometryFromEsriJson(e) {
    return d.fromJSON(e);
  },
  geometryFromGeoJson: geometryFromGeoJson,
  geometryFromApiInplace: function geometryFromApiInplace(e, t, r) {
    return (Array.isArray(t) ? t : [t]).forEach(function (t) {
      e.hasOwnProperty(t) && e[t] && (e[t] = geometryFromGeoJson(e[t], r));
    }), e;
  },
  getSpatialReference: function getSpatialReference(e) {
    return new n(e);
  },
  toFeature: function toFeature(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    return toGraphic(e, t, r ? function (e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    } : function (e) {
      return e;
    }, i);
  },
  webMercatorToGeographic: A,
  geographicToWebMercator: _,
  clone: function clone(e) {
    if (!["point", "polyline", "polygon"].includes(e.type)) throw new Error("clone does not support this type of geometry.");
    return d.fromJSON(e.toJSON());
  }
},
    processEnv = function processEnv() {
  return window.process_env;
};

processEnv() || (window.process_env = {});

var f = null == processEnv().API_BASE_URL || "" === processEnv().API_BASE_URL,
    U = null == processEnv().NEW_API_BASE_URL || "" === processEnv().NEW_API_BASE_URL,
    P = null == processEnv().PUBLIC_URL || "" === processEnv().PUBLIC_URL,
    urlJoin = function urlJoin() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  var t = e.join("/"),
      r = t.match(/(https?:\/\/)(.+)/i);
  return r ? r[1] + r[2].replace(/\/+/g, "/") : t.replace(/\/+/g, "/");
},
    I = P ? "/" : null == processEnv().PUBLIC_URL.match(/https?:\/\//i) ? processEnv().PUBLIC_URL : new URL(processEnv().PUBLIC_URL).pathname,
    v = f ? I : processEnv().API_BASE_URL.replace(/\/api$/, ""),
    h = f ? urlJoin(I, "api") : processEnv().API_BASE_URL,
    O = U ? urlJoin(I, "apigw") : processEnv().NEW_API_BASE_URL,
    apiUrl = function apiUrl(e) {
  return urlJoin(h, e);
},
    newApiUrl = function newApiUrl(e) {
  return urlJoin(O, e);
},
    pdfUrl = function pdfUrl(e) {
  return urlJoin(v, e);
},
    aggregateUrlGenerator = function aggregateUrlGenerator(e, t) {
  return function (r, i) {
    return newApiUrl(function (e, t, r, i) {
      var optional = function optional(e, t) {
        return null != e ? t : "";
      },
          s = optional(e, e),
          a = optional(t, "?".concat(t));

      return "".concat([r, i, s].map(function (e) {
        return e.replace(/^\/+/, "").replace(/\/+$/, "");
      }).filter(function (e) {
        return "" !== e;
      }).join("/")).concat(a);
    }(r, i, e, t));
  };
},
    clientCredentialsToken = function clientCredentialsToken() {
  var e = window.process_env,
      t = e.COGNITO_ACCESS_TOKEN;

  if (t) {
    var _r2 = e.COGNITO_CLOCK_DRIFT;
    if (!t) return Promise.reject(new Error("Required Cognito access token is not valid."));

    var _i2 = t.split(".")[1],
        _s2 = JSON.parse(atob(_i2));

    if (Math.floor(Date.now() / 1e3) - _r2 <= _s2.exp) return Promise.resolve(t);
  }

  var r = e.CHROMELESS_CLIENT_ID;
  if (!r) return Promise.reject(new Error("Required chromeless client ID not found."));
  var i = e.CHROMELESS_APP_SECRET;
  if (!i) return Promise.reject(new Error("Required chromeless app secret not found."));
  var s = e.CHROMELESS_AUTHORIZATION_URL;
  if (!s) return Promise.reject(new Error("Required chromeless authorization URL not found."));
  var a = btoa("".concat(r, ":").concat(i));
  return fetch(s, {
    method: "POST",
    headers: {
      Authorization: "Basic ".concat(a),
      "Content-Type": "application/x-www-form-urlencoded"
    },
    timeout: 36e6,
    body: "grant_type=client_credentials"
  }).then(function (t) {
    return t.json().then(function (t) {
      var r = t.access_token;
      if (e.COGNITO_ACCESS_TOKEN = r, !r) return Promise.reject(new Error("Required Cognito access token is not valid."));
      var i = r.split(".")[1],
          s = JSON.parse(atob(i)),
          a = Math.floor(Date.now() / 1e3),
          n = s.iat;
      return e.COGNITO_CLOCK_DRIFT = a - n, r;
    });
  });
},
    userPoolToken = function userPoolToken() {
  var e = get("cognitoConfig");
  if (null == e) return Promise.resolve("");
  var t = JSON.parse(e);
  return new Promise(function (e, r) {
    var i = new E(t).getCurrentUser();
    null != i ? i.getSession(function (t, i) {
      t ? r(t) : e(i.getIdToken().getJwtToken());
    }) : e(null);
  });
},
    F = Object.freeze({
  __proto__: null,
  clientCredentialsToken: clientCredentialsToken,
  userPoolToken: userPoolToken
}),
    C = {
  Success: 0,
  UnknownError: 10,
  HttpError: 11,
  ValidationError: 20
},
    M = {
  Generic: 0,
  Validation: 1
};

var APIError = /*#__PURE__*/function (_Error) {
  _inherits(APIError, _Error);

  var _super = _createSuper(APIError);

  function APIError(e, t) {
    var _this;

    _classCallCheck(this, APIError);

    _this = _super.call(this, e), _this.apiResultObj = void 0, _this.errorFile = void 0, _this.apiResultObj = t, t && t.errorFile && (_this.errorFile = {
      base64Data: t.errorFile
    }), _this.detailedStatus = t && t.hasOwnProperty("detailedStatus") ? t.detailedStatus : C.ValidationError, _this.name = _this.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor) : _this.stack = new Error().stack;
    return _this;
  }

  _createClass(APIError, [{
    key: "setErrorFileName",
    value: function setErrorFileName(e) {
      this.errorFile = _objectSpread(_objectSpread({}, this.errorFile), {}, {
        fileName: e
      });
    }
  }]);

  return APIError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var APIErrorInvalidSchema = /*#__PURE__*/function (_Error2) {
  _inherits(APIErrorInvalidSchema, _Error2);

  var _super2 = _createSuper(APIErrorInvalidSchema);

  function APIErrorInvalidSchema(e) {
    var _this2;

    _classCallCheck(this, APIErrorInvalidSchema);

    _this2 = _super2.call(this, new G().errorsText(e)), _this2.schemaValidatorErrors = e, _this2.name = _this2.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(_assertThisInitialized(_this2), _this2.constructor) : _this2.stack = new Error().stack;
    return _this2;
  }

  return APIErrorInvalidSchema;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var APIErrorWithCode = /*#__PURE__*/function (_APIError) {
  _inherits(APIErrorWithCode, _APIError);

  var _super3 = _createSuper(APIErrorWithCode);

  function APIErrorWithCode(e) {
    var _this3;

    _classCallCheck(this, APIErrorWithCode);

    _this3 = _super3.call(this, null != e.errorCodeList && 0 !== e.errorCodeList.length || !function (e) {
      var t = "string" == typeof e;

      try {
        if (t && null != JSON.parse(e)) return !1;
      } catch (r) {
        return t;
      }

      return t;
    }(e.model) ? APIErrorWithCode.getGenericMessage(e.errorCodeList) : e.model, e), _this3.errorCodeList = e.errorCodeList, _this3.model = e.model, _this3.name = _this3.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(_assertThisInitialized(_this3), _this3.constructor) : _this3.stack = new Error().stack;
    return _this3;
  }

  _createClass(APIErrorWithCode, null, [{
    key: "getGenericMessage",
    value: function getGenericMessage(e) {
      try {
        return e.detailedStatus && e.detailedStatus === C.ValidationError ? "API Validation Codes (".concat(e.errorCodeList.join(", "), ")") : e.errorCodeList && e.errorCodeList.length > 0 ? "API Error Codes (".concat(e.errorCodeList.join(", "), ")") : "API Error";
      } catch (t) {
        return "API Error";
      }
    }
  }]);

  return APIErrorWithCode;
}(APIError);

var APICommandFailed = /*#__PURE__*/function (_APIError2) {
  _inherits(APICommandFailed, _APIError2);

  var _super4 = _createSuper(APICommandFailed);

  function APICommandFailed(e) {
    _classCallCheck(this, APICommandFailed);

    return _super4.call(this, "", e);
  }

  return APICommandFailed;
}(APIError);

var D = new G({
  meta: !1
});
D.addMetaSchema("default" in R ? R.default : R), D._opts.defaultMeta = R.id;

var validateResults = function validateResults(e, t) {
  return e.then(function (e) {
    if (!t(e)) throw new APIErrorInvalidSchema(t.errors);
    return e;
  });
},
    _wrapFetchPromise = function _wrapFetchPromise(e, t) {
  var r = fetch(e, t);
  return r.catch(function (e) {
    return e.name, e;
  }), null != r.finally ? r : new Promise(function (e, t) {
    r.then(e, t);
  });
},
    getAuthorizationHeader = function getAuthorizationHeader() {
  return (window.process_env.USE_USER_POOL ? userPoolToken() : clientCredentialsToken()).then(function (e) {
    if (null == e) return {};
    var t = get("userGuid");
    return t ? {
      Authorization: "Bearer ".concat(e),
      "user-guid": t
    } : {
      Authorization: "Bearer ".concat(e)
    };
  });
};

var Request = /*#__PURE__*/function () {
  function Request() {
    _classCallCheck(this, Request);
  }

  _createClass(Request, null, [{
    key: "_baseRequest",
    value: function () {
      var _baseRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t, r) {
        var i,
            s,
            a,
            n,
            o,
            u,
            l,
            d,
            p,
            _e2,
            _t4,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : "application/json";
                s = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {};
                a = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : !0;
                n = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : null;
                o = t, u = {
                  method: e,
                  headers: _objectSpread({
                    "Content-Type": i,
                    Accept: "application/json"
                  }, s),
                  timeout: 36e6
                };

                if (null != n && (u.signal = n), "multipart/form-data" === i && (u = {
                  method: e,
                  headers: s
                }), "GET" === e) {
                  if (r instanceof Array && r.length > 0) {
                    o = "".concat(t).concat(r.reduce(function (e, t) {
                      return "".concat(e).concat("" === e ? "?" : "&").concat(t.key, "=").concat(t.value);
                    }, ""));
                  }
                } else u.body = "application/json" === i && r ? JSON.stringify(r) : r;

                _context3.next = 8;
                return getAuthorizationHeader();

              case 8:
                l = _context3.sent;
                l && (u.headers = _objectSpread(_objectSpread({}, u.headers), l));
                _context3.next = 12;
                return _wrapFetchPromise(o, u);

              case 12:
                d = _context3.sent;

                if (!(d.status >= 400 && d.status <= 599)) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt("return", function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                    var t, r, i, s;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return e.text();

                          case 2:
                            t = _context.sent;
                            r = {
                              status: e.status
                            };

                            try {
                              Object.assign(r, JSON.parse(t)), i = r.exceptionMessage || r.message || e.statusText;
                            } catch (a) {
                              i = e.statusText;
                            }

                            r.message = i;
                            s = Object.prototype.hasOwnProperty.call(r, "errors");
                            throw r.detailedStatus = s && r.errors.every(function (e) {
                              return e.type === M.Validation;
                            }) ? C.ValidationError : C.HttpError, s ? (r.errorCodeList = r.errors.filter(function (e) {
                              return e.code;
                            }).map(function (e) {
                              return e.code;
                            }), r.isNewApiErrorFormat = !0) : r.isNewApiErrorFormat = !1, new APIError(i, r);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }()(d));

              case 15:
                if (!d.ok) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
                    var _t3;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(204 === e.status && e.headers.has("S3-Location"))) {
                              _context2.next = 5;
                              break;
                            }

                            _t3 = e.headers.get("S3-Location");
                            _context2.next = 4;
                            return fetch(_t3);

                          case 4:
                            return _context2.abrupt("return", _context2.sent.json());

                          case 5:
                            if (!(-1 === [201, 204].indexOf(e.status))) {
                              _context2.next = 13;
                              break;
                            }

                            _context2.prev = 6;
                            return _context2.abrupt("return", e.json());

                          case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](6);
                            return _context2.abrupt("return", e.text());

                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[6, 10]]);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }()(d);

              case 18:
                _context3.t0 = _context3.sent;
                _context3.next = 22;
                break;

              case 21:
                _context3.t0 = null;

              case 22:
                p = _context3.t0;

                if (!p) {
                  _context3.next = 36;
                  break;
                }

                if (!(void 0 !== p.isAccepted)) {
                  _context3.next = 27;
                  break;
                }

                if (!(g(p, "childCommandResults").filter(function (e) {
                  return !e.isAccepted;
                }).length > 0)) {
                  _context3.next = 27;
                  break;
                }

                throw new APICommandFailed(p);

              case 27:
                _e2 = p;

                if (!(p.errors && p.errors.length > 0 && (!_e2.errorCodeList || 0 === _e2.errorCodeList.length))) {
                  _context3.next = 30;
                  break;
                }

                throw p.errors[0] instanceof String ? (_e2.message = p.errors.join("|"), _e2.status = 400, new APIError(_e2.message, _e2)) : (_e2.message = p.errors.reduce(function (e, t) {
                  return "".concat(e, "\n").concat(t.message);
                }, ""), _e2.status = 400, new APIError(_e2.message, _e2));

              case 30:
                if (!(_e2.errorCodeList && _e2.errorCodeList.length > 0 && !p.success && a)) {
                  _context3.next = 32;
                  break;
                }

                throw new APIErrorWithCode(_e2);

              case 32:
                if (!(202 === d.status && Array.isArray(_e2) && _e2.find(function (e) {
                  return "Failure" === e.operation;
                }))) {
                  _context3.next = 35;
                  break;
                }

                _t4 = _e2.filter(function (e) {
                  return "Failure" === e.operation;
                }).flatMap(function (e) {
                  return e.errors;
                }).reduce(function (e, t) {
                  return "".concat(e, "\n").concat(t.code);
                }, "");
                throw new APIError(_t4, _e2);

              case 35:
                return _context3.abrupt("return", !1 === a ? _e2 : void 0 !== p.model ? p.model : p);

              case 36:
                return _context3.abrupt("return", {});

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _baseRequest(_x, _x2, _x3) {
        return _baseRequest2.apply(this, arguments);
      }

      return _baseRequest;
    }()
  }, {
    key: "delete",
    value: function _delete(e, t) {
      return Request._baseRequest("DELETE", e, t);
    }
  }, {
    key: "get",
    value: function get(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var s = arguments.length > 4 ? arguments[4] : undefined;
      var a = r ? {
        "user-guid": r
      } : {};
      return Request._baseRequest("GET", e, t, null, _objectSpread(_objectSpread({}, a), i), !0, s);
    }
  }, {
    key: "patch",
    value: function patch(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "application/json";
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      return Request._baseRequest("PATCH", e, t, r, i, s);
    }
  }, {
    key: "post",
    value: function post(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "application/json";
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      var a = arguments.length > 5 ? arguments[5] : undefined;
      return Request._baseRequest("POST", e, t, r, i, s, a);
    }
  }, {
    key: "put",
    value: function put(e, t) {
      return Request._baseRequest("PUT", e, t);
    }
  }, {
    key: "uploadToS3",
    value: function uploadToS3(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "multipart/form-data";
      return _wrapFetchPromise(e, {
        body: t,
        headers: {
          "Content-Type": r
        },
        method: "PUT"
      }).then(function (e) {
        if (!e.ok) throw new Error("".concat(e.status, ": ").concat(e.statusText));
        return e;
      });
    }
  }]);

  return Request;
}();

var N = apiUrl("OnSiteMonitorFile/GetOnsiteConnectionTypeList"),
    q = apiUrl("OnSiteMonitorFile/GetOnsiteEquipmentList"),
    b = apiUrl("OnsiteMonitorFile/GetUrlForRegistration"),
    B = apiUrl("OnsiteMonitorFile/GetUserOnsiteConnections"),
    w = apiUrl("OnsiteMonitorFile/SaveUserOnsiteConnections"),
    V = apiUrl("OnsiteMonitorFile/AddUserOnsiteConnection"),
    x = apiUrl("OnsiteMonitorFile/UpdateUserOnsiteConnection"),
    Y = apiUrl("OnsiteMonitorFile/DeleteUserOnsiteConnection"),
    j = Object.freeze({
  __proto__: null,
  REQUEST_TELEMATICS_GET_CONNECTION_TYPE_LIST: N,
  REQUEST_TELEMATICS_GET_EQUIPMENT_NAME_LIST: q,
  REQUEST_TELEMATICS_GET_REGISTRATION_URL: b,
  REQUEST_TELEMATICS_GET_USER_CONNECTIONS: B,
  SAVE_USER_ONSITE_CONNECTIONS: w,
  ADD_USER_ONSITE_CONNECTION: V,
  UPDATE_USER_ONSITE_CONNECTION: x,
  DELETE_USER_ONSITE_CONNECTION: Y,
  getConnectionTypeList: function getConnectionTypeList(e) {
    return Request.post(N, e);
  },
  getOnSiteEquipmentList: function getOnSiteEquipmentList(e) {
    return Request.post(q, e);
  },
  getUrlForRegistration: function getUrlForRegistration(e) {
    return Request.post(b, e);
  },
  getUserAccount: function getUserAccount(e) {
    return Request.post(B, e);
  },
  saveUserAccount: function saveUserAccount(e) {
    return Request.post(w, e);
  },
  addUserOnsiteConnection: function addUserOnsiteConnection(e) {
    return Request.post(V, e);
  },
  updateUserOnsiteConnection: function updateUserOnsiteConnection(e) {
    return Request.post(x, e);
  },
  deleteUserOnsiteConnection: function deleteUserOnsiteConnection(e) {
    return Request.post(Y, e);
  }
}),
    H = apiUrl("Address/GetAddressTypes"),
    z = apiUrl("Address/GetCountries"),
    k = apiUrl("Address/GetStates"),
    $ = Object.freeze({
  __proto__: null,
  REQUEST_ADDRESS_TYPE: H,
  REQUEST_COUNTRIES: z,
  REQUEST_STATES: k,
  getStateList: function getStateList(e) {
    return Request.post(k, e);
  }
}),
    Q = apiUrl("AdminScripts/RunAdminScript"),
    W = Object.freeze({
  __proto__: null,
  RUN_ADMIN_SCRIPT_URL: Q,
  runAdminScript: function runAdminScript(e, t, r) {
    return Request.post(Q, {
      UserGuid: e,
      Script: t,
      Params: r
    });
  }
}),
    Z = t({
  reducerPath: "ai360Api",
  baseQuery: e({
    baseUrl: newApiUrl(""),
    prepareHeaders: function () {
      var _prepareHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, _ref3) {
        var t, r;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = _ref3.getState;
                _context4.next = 3;
                return getAuthorizationHeader();

              case 3:
                r = _context4.sent;
                return _context4.abrupt("return", (Object.keys(r).forEach(function (t) {
                  e.set(t, r[t]);
                }), e));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function prepareHeaders(_x6, _x7) {
        return _prepareHeaders.apply(this, arguments);
      }

      return prepareHeaders;
    }()
  }),
  endpoints: function endpoints(e) {
    return {};
  },
  tagTypes: ["LoginPreferences", "UserPreferences"]
}),
    K = apiUrl("User/GetAutoSearchList"),
    J = apiUrl("User/GetUserList"),
    X = apiUrl("User/GetTimeZoneList"),
    ee = apiUrl("User/UserDeactivate"),
    te = apiUrl("User/GetSelectAllList"),
    re = apiUrl("User/ExportList"),
    ie = apiUrl("User/ValidateImport"),
    se = apiUrl("User/ImportFile"),
    ae = Z.injectEndpoints({
  endpoints: function endpoints(e) {
    return {
      getAllLoginPreferences: e.query({
        query: function query(e) {
          return {
            url: "user/v1.0/login/".concat(e, "/preference"),
            method: "GET"
          };
        },
        providesTags: ["LoginPreferences"]
      }),
      getAllUserPreferences: e.query({
        query: function query(e) {
          return {
            url: "user/v1.0/".concat(e, "/preference"),
            method: "GET"
          };
        },
        providesTags: ["UserPreferences"]
      }),
      getLoginPreferences: e.query({
        query: function query(_ref4) {
          var e = _ref4.loginGuid,
              t = _ref4.names;
          return {
            url: "user/v1.0/login/".concat(e, "/preference"),
            method: "POST",
            body: {
              name: t
            }
          };
        },
        providesTags: ["LoginPreferences"]
      }),
      getUserPreferences: e.query({
        query: function query(_ref5) {
          var e = _ref5.userGuid,
              t = _ref5.names;
          return {
            url: "user/v1.0/".concat(e, "/preference"),
            method: "POST",
            body: {
              name: t
            }
          };
        },
        providesTags: ["UserPreferences"]
      }),
      saveLoginPreference: e.mutation({
        query: function query(_ref6) {
          var e = _ref6.loginGuid,
              t = _ref6.name,
              r = _ref6.value;
          return {
            url: "user/v1.0/login/".concat(e, "/preference/").concat(t),
            method: "PUT",
            body: {
              value: r
            }
          };
        },
        invalidatesTags: ["LoginPreferences"]
      }),
      saveUserPreference: e.mutation({
        query: function query(_ref7) {
          var e = _ref7.userGuid,
              t = _ref7.name,
              r = _ref7.value;
          return {
            url: "user/v1.0/".concat(e, "/preference/").concat(t),
            method: "PUT",
            body: {
              value: r
            }
          };
        },
        invalidatesTags: ["UserPreferences"]
      })
    };
  }
}),
    ne = ae.useGetAllLoginPreferencesQuery,
    oe = ae.useGetAllUserPreferencesQuery,
    ue = ae.useGetLoginPreferencesQuery,
    le = ae.useGetUserPreferencesQuery,
    de = ae.useSaveLoginPreferenceMutation,
    pe = ae.useSaveUserPreferenceMutation,
    ce = Object.freeze({
  __proto__: null,
  AUTO_SEARCH_URL: K,
  GET_USERS_LIST: J,
  GET_USER_TIMEZONE: X,
  USER_DEACTIVATE: ee,
  SELECT_ALL_USER: te,
  EXPORT_LIST: re,
  IMPORT_USER_VALID_URL: ie,
  IMPORT_USER_LIST: se,
  UserPreferenceKeys: {
    agrianLastConversionDate: "AgrianLastConversionDate",
    agrianLastConversionTime: "AgrianLastConversionTime",
    autoTraceDefault: "AutoTraceDefault",
    batchZapperLastUsedOwnerGuid: "BatchZapperLastUsedOwnerGuid",
    colorScheme: "ColorScheme",
    fertilizerRecSummaryTotalingUnit: "FertilizerRecSummaryTotalingUnit",
    labAccount: "LabAccount",
    receiveAppNotificationsForImportSurfaces: "ReceiveAppNotificationsForImportSurfaces",
    receiveAppNotificationsForRecSurfaces: "ReceiveAppNotificationsForRecSurfaces",
    receiveAppNotificationsForReports: "ReceiveAppNotificationsForReports",
    receiveAppNotificationsForWorkOrders: "ReceiveAppNotificationsForWorkOrders",
    receiveEmailNotificationsForImportSurfaces: "ReceiveEmailNotificationsForImportSurfaces",
    receiveEmailNotificationsForRecSurfaces: "ReceiveEmailNotificationsForRecSurfaces",
    receiveEmailNotificationsForReports: "ReceiveEmailNotificationsForReports",
    receiveEmailNotificationsForWorkOrders: "ReceiveEmailNotificationsForWorkOrders",
    standardLayerPreferences: "StandardLayerPreferences",
    yieldByAnalysisReportCategory: "YieldByAnalysisReportCategory"
  },
  StandardFeatureLayerNames: {
    fields: "Fields",
    nonFieldFeatures: "NonFieldFeatures"
  },
  getNavigationLists: function getNavigationLists(e, t) {
    return Request.post(apiUrl("User/GetNavigationLists"), {
      UserGuid: e,
      Model: t
    });
  },
  getUserPreferenceByKey: function getUserPreferenceByKey(e, t) {
    return Request.post(apiUrl("UserPreference/GetUserPreferenceByKey"), {
      UserGuid: e,
      Model: t
    });
  },
  getUserPreferencesByKeys: function getUserPreferencesByKeys(e, t) {
    return Request.post(apiUrl("UserPreference/GetUserPreferencesByKeys"), {
      UserGuid: e,
      Model: t
    });
  },
  saveClientConnectionId: function saveClientConnectionId(e, t) {
    return Request.post(apiUrl("User/UpdateClientConnectionId"), {
      UserGuid: e,
      Model: t
    });
  },
  saveUserPreference: function saveUserPreference(e, t, r) {
    var i = "string" != typeof r ? JSON.stringify(r) : r;
    return Request.post(apiUrl("UserPreference/SaveUserPreference"), {
      UserGuid: e,
      Model: {
        key: t,
        value: i
      }
    });
  },
  default: ae,
  useGetAllLoginPreferencesQuery: ne,
  useGetAllUserPreferencesQuery: oe,
  useGetLoginPreferencesQuery: ue,
  useGetUserPreferencesQuery: le,
  useSaveLoginPreferenceMutation: de,
  useSaveUserPreferenceMutation: pe
}),
    me = apiUrl("Analytics/GetAnalyticDashboardTypes"),
    ye = apiUrl("Analytics/GetQuickSightDashboard"),
    ge = Object.freeze({
  __proto__: null,
  GET_DASHBOARD_LIST: me,
  GET_DASHBOARD_EMBED_URL: ye,
  getAnalyticDashboardTypes: function getAnalyticDashboardTypes(e) {
    return Request.post(me, {
      UserGuid: e
    });
  },
  getQuickSightDashboard: function getQuickSightDashboard(e, t) {
    return Request.post(ye, {
      Model: e,
      UserGuid: t
    });
  }
}),
    Ge = apiUrl("AgBytes/GetCropAgBytesList"),
    Re = apiUrl("AgBytes/GetCropClassAgBytesList"),
    Ee = apiUrl("AgBytes/GetBrandOrganizationCropList"),
    Se = apiUrl("AgBytes/GetVarietyHybridFilterList"),
    Te = Object.freeze({
  __proto__: null,
  REQUEST_CROP: Ge,
  REQUEST_CROP_CLASS: Re,
  REQUEST_BRAND_ORG: Ee,
  REQUEST_VARIETY_HYBRID: Se,
  requestVarietyHybrid: function requestVarietyHybrid(_ref8) {
    var e = _ref8.UserGuid,
        t = _ref8.Model;
    return Request.post(Se, {
      UserGuid: e,
      Model: t
    });
  }
}),
    Ae = apiUrl("SetupCustomer/AddCustomer"),
    _e = apiUrl("SetupCustomer/AddCustomerOracleIdCheck"),
    Le = apiUrl("SetupCustomer/CustomerNameExists"),
    fe = apiUrl("SetupCompany/GetDataPoolingCustomerDefault"),
    Ue = apiUrl("SetupCustomer/GetAgvanceCustomerList"),
    Pe = apiUrl("SetupCustomer/GetCustomer"),
    Ie = apiUrl("SetupCustomer/GetAgvanceCustomer"),
    ve = apiUrl("SetupCustomer/GetEnrollmentForm"),
    he = apiUrl("SetupCustomer/UpdateCustomer"),
    Oe = apiUrl("SetupCustomer/UpdateEnrollmentForm"),
    Fe = apiUrl("SetupCustomer/SendAuthentication"),
    Ce = apiUrl("SetupCustomer/GetAgvanceCustomerListWithQueryParams"),
    Me = Object.freeze({
  __proto__: null,
  ADD_CUSTOMER: Ae,
  ADD_CUSTOMER_ORACLE_ID: _e,
  CUSTOMER_NAME_EXISTS: Le,
  GET_OWNER_COMMUNITY_DATA: fe,
  GET_AGVANCE_CUSTOMER_LIST: Ue,
  GET_CUSTOMER: Pe,
  GET_AGVANCE_CUSTOMER: Ie,
  GET_ENROLLMENT_FORM: ve,
  UPDATE_CUSTOMER: he,
  UPDATE_ENROLLMENT_FORM: Oe,
  SEND_AUTHENTICATION: Fe,
  GET_AGVANCE_CUSTOMER_LIST_WITH_QUERY_PARAMS: Ce,
  activateCustomer: function activateCustomer(e, t) {
    return Request.put(apiUrl("SetupCustomer/CustomerActivate"), {
      UserGuid: e,
      Model: t
    });
  },
  AddCustomerOracleIdCheck: function AddCustomerOracleIdCheck(e) {
    return Request.post(_e, e);
  },
  addCustomer: function addCustomer(e) {
    return Request.post(Ae, e);
  },
  customerNameExists: function customerNameExists(e) {
    return Request.post(Le, e);
  },
  deactivateCustomer: function deactivateCustomer(e, t) {
    return Request.delete(apiUrl("SetupCustomer/CustomerDeactivate"), {
      UserGuid: e,
      Model: t
    });
  },
  getCustomer: function getCustomer(e) {
    return Request.post(Pe, e);
  },
  getAgvanceCustomer: function getAgvanceCustomer(e) {
    return Request.post(Ie, e);
  },
  getAgvanceCustomerList: function getAgvanceCustomerList(e) {
    return Request.post(Ue, e);
  },
  getAgvanceCustomerListWithNameSearch: function getAgvanceCustomerListWithNameSearch(e) {
    return Request.post(Ce, e);
  },
  getCustomerSalespersonList: function getCustomerSalespersonList(e) {
    return Request.post(apiUrl("SetupCustomer/GetCustomerSalespersonList"), {
      UserGuid: e
    });
  },
  getEnrollmentForm: function getEnrollmentForm(e, t) {
    return Request.post(ve, {
      UserGuid: e,
      Model: t
    });
  },
  moveCustomerFields: function moveCustomerFields(e, t, r, i, s, a) {
    return Request.post(apiUrl("SetupCustomer/MoveCustomerFields"), {
      UserGuid: e,
      Model: {
        CustomerGuid: t,
        FarmName: r,
        FieldGuidList: i,
        AgvanceCustomerGuid: s,
        AgvanceFieldOrgLevelGuid: a
      }
    });
  },
  updateCustomer: function updateCustomer(e) {
    return Request.post(he, e);
  },
  getOwnerCommunityData: function getOwnerCommunityData(e) {
    return Request.post(fe, e);
  },
  sendAuthentication: function sendAuthentication(e, t) {
    return Request.post(Fe, {
      UserGuid: e,
      Model: t
    });
  },
  updateEnrollmentForm: function updateEnrollmentForm(e, t) {
    return Request.post(Oe, {
      UserGuid: e,
      Model: t
    });
  }
}),
    De = apiUrl("EquipmentProfile/GetEquipmentProfileList"),
    Ne = apiUrl("EquipmentProfile/AddEquipmentProfile"),
    qe = apiUrl("EquipmentProfile/UpdateEquipmentProfile"),
    be = apiUrl("EquipmentProfile/GetEquipmentProfile"),
    Be = apiUrl("EquipmentProfile/SetEquipmentProfileInactive"),
    we = apiUrl("EquipmentProfile/GetEquipmentProfileAutoSearchList"),
    Ve = apiUrl("EquipmentProfile/GetEquipmentTypeFilterList"),
    xe = apiUrl("AgBytes/GetEquipment"),
    Ye = apiUrl("EquipmentProfile/GetManufacturerFilterList"),
    je = apiUrl("AgBytes/GetEquipmentAgBytesList"),
    He = apiUrl("EquipmentProfile/GetOwnerOperatorEquipmentList"),
    ze = apiUrl("OnSiteMonitorFile/SearchOnsiteUserList"),
    ke = apiUrl("EquipmentProfile/SearchEquipmentWithName"),
    $e = Object.freeze({
  __proto__: null,
  FETCH_URL: De,
  CREATE: Ne,
  UPDATE: qe,
  GETRECORD: be,
  DELETE: Be,
  AUTO_SEARCH_URL: we,
  EQUIPMENT_FILTER_URL: Ve,
  GET_AGBYTES_EQUIPMENT_URL: xe,
  GET_MANUFACTURER_FILTER_LIST: Ye,
  GET_EQUIPMENT_AGBYTES_LIST: je,
  GET_OWNER_OPERATOR_EQUIPMENT_LIST: He,
  GET_ONSITE_USER_LIST: ze,
  SEARCH_EQUIPMENT_WITH_NAME: ke,
  getEquipmentProfileAutoComplete: function getEquipmentProfileAutoComplete(e, t) {
    return Request.post(apiUrl("EquipmentProfile/GetEquipmentProfileAutoComplete"), {
      UserGuid: e,
      Model: t
    });
  },
  createEquipmentProfile: function createEquipmentProfile(e) {
    return Request.post(Ne, e);
  },
  getOwnerOperatorEquipmentList: function getOwnerOperatorEquipmentList(e) {
    return Request.post(He, e);
  },
  searchOnsiteUsers: function searchOnsiteUsers(e, t) {
    return Request.post(ze, {
      UserGuid: e,
      Model: t
    });
  },
  searchEquipmentWithName: function searchEquipmentWithName(e, t) {
    return Request.post(ke, {
      UserGuid: e,
      Model: t
    });
  }
}),
    fetchByList = function fetchByList(e, t, r) {
  if (0 === r.length) return Promise.resolve([]);
  var i = Array.isArray(r) ? r : [r],
      s = new SplitRequestTask(e.filterName, e.limit, i),
      a = new BasicResponseTask();
  return fetchBy(s, a, e, t).then(function (e) {
    return e.flat();
  });
},
    fetchBy = function fetchBy(e, t, r, i) {
  var s = doGenerateRequest(r.endpoint.aggregateUrl, r.endpoint.name),
      a = r.endpoint.extractFromResponse;
  return sendRequests(e, t, i, s, a);
},
    sendRequests = function sendRequests(e, t, r, i, s) {
  var a = [];
  var n = !1,
      o = null;

  var handleRequestTask = function handleRequestTask(t) {
    var r = e.handleRequest();
    n = r.doContinuation, o = r.queryStringComponents;
    return i(appendToQueryString(t, r.queryStringComponents)).then(handleResponseTask);
  },
      handleResponseTask = function handleResponseTask(e) {
    a.push(s(e));
    var u = t.handleResponse(e);

    if (u.doContinuation) {
      var _e3 = appendToQueryString(r, u.queryStringComponents);

      return i(appendToQueryString(_e3, o)).then(handleResponseTask);
    }

    return n ? handleRequestTask(appendToQueryString(r, u.queryStringComponents)) : a;
  };

  return handleRequestTask(r);
},
    doGenerateRequest = function doGenerateRequest(e, t) {
  return function (r) {
    var i = e(t, r.toString());
    return Request.get(i);
  };
},
    appendToQueryString = function appendToQueryString(e, t) {
  return null === t ? e.copy() : t.reduce(function (e, t) {
    return e.append(t.name, t.values);
  }, e.copy());
};

var BasicRequestTask = /*#__PURE__*/function () {
  function BasicRequestTask() {
    _classCallCheck(this, BasicRequestTask);
  }

  _createClass(BasicRequestTask, [{
    key: "handleRequest",
    value: function handleRequest() {
      return {
        doContinuation: !1,
        queryStringComponents: null
      };
    }
  }]);

  return BasicRequestTask;
}();

var SplitRequestTask = /*#__PURE__*/function () {
  function SplitRequestTask(e, t, r) {
    _classCallCheck(this, SplitRequestTask);

    this.filterName = e, this.limit = t, this.remaining = r;
  }

  _createClass(SplitRequestTask, [{
    key: "handleRequest",
    value: function handleRequest() {
      var e = this.remaining.length <= this.limit ? this.remaining.length : this.limit,
          t = this.remaining.slice(0, e);
      return this.remaining = this.remaining.slice(e), 0 === t.length ? {
        doContinuation: !1,
        queryStringComponents: null
      } : {
        doContinuation: 0 !== this.remaining.length,
        queryStringComponents: [{
          name: this.filterName,
          values: t
        }]
      };
    }
  }]);

  return SplitRequestTask;
}();

var BasicResponseTask = /*#__PURE__*/function () {
  function BasicResponseTask() {
    _classCallCheck(this, BasicResponseTask);
  }

  _createClass(BasicResponseTask, [{
    key: "handleResponse",
    value: function handleResponse(e) {
      return {
        doContinuation: !1,
        queryStringComponents: null
      };
    }
  }]);

  return BasicResponseTask;
}();

var QueryString = /*#__PURE__*/function () {
  function QueryString() {
    _classCallCheck(this, QueryString);

    this.nameValuePairs = [];
  }

  _createClass(QueryString, [{
    key: "copy",
    value: function copy() {
      var e = new QueryString();
      return e.nameValuePairs = _toConsumableArray(this.nameValuePairs), e;
    }
  }, {
    key: "append",
    value: function append(e, t) {
      if (Array.isArray(t)) {
        var _iterator = _createForOfIteratorHelper(t),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _r3 = _step.value;
            null != _r3 && this.pushNameValuePair(e, null == _r3 ? void 0 : _r3.toString());
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else this.pushNameValuePair(e, t);

      return this;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      return this.nameValuePairs = this.nameValuePairs.filter(function (t) {
        return t.name !== e;
      }), this.pushNameValuePair(e, t), this;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e = new URLSearchParams();

      var _iterator2 = _createForOfIteratorHelper(this.nameValuePairs),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t5 = _step2.value;
          e.append(_t5.name, _t5.value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return e.toString();
    }
  }, {
    key: "pushNameValuePair",
    value: function pushNameValuePair(e, t) {
      this.nameValuePairs.push(new NameValuePair(e, t));
    }
  }]);

  return QueryString;
}();

var NameValuePair = function NameValuePair(e, t) {
  _classCallCheck(this, NameValuePair);

  this.name = e, this.value = t;
};

var Qe = aggregateUrlGenerator("agvance", "v1.0"),
    getCustomer = function getCustomer(e, t) {
  return Request.get(Qe("customer/{".concat(e, "}")), null, null, t);
},
    We = Object.freeze({
  __proto__: null,
  getCustomer: getCustomer,
  getFieldList: function getFieldList(e, t) {
    var r = {
      "user-guid": t
    };
    return Request.get(Qe("field?customerGuid=".concat(e)), null, null, r);
  },
  getClassifications: function getClassifications(e) {
    var t = new QueryString();
    return t.append("orgLevelGuid", e.orgLevelGuid), null != e.agvanceFieldGuid && t.append("agvanceFieldGuid", e.agvanceFieldGuid), Request.get(Qe("classification", t.toString()));
  },
  refreshClassifications: function refreshClassifications(e) {
    return Request.post(Qe("classification/refresh"), e);
  }
}),
    Ze = aggregateUrlGenerator("field", "v1.0"),
    transformShape$2 = function transformShape$2(e) {
  return L.geometryFromApiInplace(e, ["shape", "centroid"], L.getSpatialReference(102100));
},
    Ke = 2147483647,
    assignNullableGuid = function assignNullableGuid(e) {
  return "" === e || "00000000-0000-0000-0000-000000000000" === e ? null : e;
},
    Je = apiUrl("SetupField/GetAgvanceFieldList"),
    Xe = apiUrl("SetupField/GetAgvanceFieldClassificationList"),
    et = apiUrl("SetupField/GetAgvanceFieldData"),
    tt = apiUrl("SetupField/CombineFields"),
    rt = 102100,
    it = {
  customerGuid: "customerGuid",
  customerName: "customerName",
  farmName: "farmName",
  fieldArea: "calculatedArea",
  fieldGuid: "fieldGuid",
  fieldBoundaryGuid: "fieldBoundaryGuid",
  fieldBoundaryPolygonGuid: "fieldBoundaryPolygonGuid",
  fieldName: "name",
  active: "activeYn"
};

var FieldBoundaryEndpoint = /*#__PURE__*/function () {
  function FieldBoundaryEndpoint() {
    _classCallCheck(this, FieldBoundaryEndpoint);
  }

  _createClass(FieldBoundaryEndpoint, null, [{
    key: "baseQueryString",
    value: function baseQueryString(e, t, r, i) {
      var s = new QueryString();
      return s.append("spatialReference", "wgs84"), e && s.append("extent", e.spatialReference.isWebMercator ? L.extentToQueryParameter(L.webMercatorToGeographic(e)) : L.extentToQueryParameter(e)), t && s.append("simplificationScale", t.toString()), r && s.append("isActive", r.toString()), s.append("pageSize", (null != i ? i : 1250).toString()), s;
    }
  }, {
    key: "convertQueryStringToBodyObject",
    value: function convertQueryStringToBodyObject(e) {
      var t = (e = e.replace("?", "")).split("&"),
          r = {};
      return t.forEach(function (e) {
        var _e$split = e.split("="),
            _e$split2 = _slicedToArray(_e$split, 2),
            t = _e$split2[0],
            i = _e$split2[1];

        r[t] = decodeURIComponent(i);
      }), r;
    }
  }, {
    key: "extentHelper",
    value: function extentHelper(e) {
      return null == e ? null : e.spatialReference.isWebMercator ? L.extentToQueryParameter(L.webMercatorToGeographic(e)) : L.extentToQueryParameter(e);
    }
  }]);

  return FieldBoundaryEndpoint;
}();

var fetchFieldBoundariesByCurrentUserGuidAndExtent = function fetchFieldBoundariesByCurrentUserGuidAndExtent(e, t, r, i) {
  var s = {
    boundary: [],
    customer: [],
    extent: FieldBoundaryEndpoint.extentHelper(e),
    field: [],
    isActive: r,
    pageSize: Ke,
    simplificationScale: t,
    spatialReference: "wgs84"
  };
  return fetchBoundaries(s, i);
},
    fetchFieldBoundariesByCustomerGuid = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t, r, i, s) {
    var a;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(0 === e.filter(function (e) {
              return e;
            }).length)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", Promise.resolve([]));

          case 2:
            a = {
              boundary: [],
              customer: e,
              extent: FieldBoundaryEndpoint.extentHelper(t),
              field: [],
              isActive: i,
              pageSize: Ke,
              simplificationScale: r,
              spatialReference: "wgs84"
            };
            return _context5.abrupt("return", fetchBoundaries(a, s));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFieldBoundariesByCustomerGuid(_x8, _x9, _x10, _x11, _x12) {
    return _ref9.apply(this, arguments);
  };
}(),
    fetchFieldBoundariesByFieldGuid = function fetchFieldBoundariesByFieldGuid(e, t, r, i, s) {
  if (0 === e.filter(function (e) {
    return e;
  }).length) return Promise.resolve([]);
  var a = {
    boundary: [],
    customer: [],
    extent: FieldBoundaryEndpoint.extentHelper(t),
    field: e,
    isActive: i,
    pageSize: Ke,
    simplificationScale: r,
    spatialReference: "wgs84"
  };
  return fetchBoundaries(a, s);
},
    fetchFieldBoundariesByBoundaryGuid = function fetchFieldBoundariesByBoundaryGuid(e, t, r, i, s) {
  if (0 === e.filter(function (e) {
    return e;
  }).length) return Promise.resolve([]);
  var a = {
    boundary: e,
    customer: [],
    extent: FieldBoundaryEndpoint.extentHelper(t),
    field: [],
    isActive: i,
    pageSize: Ke,
    simplificationScale: r,
    spatialReference: "wgs84"
  };
  return fetchBoundaries(a, s);
},
    fetchBoundaries = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Request.post(Ze("boundary"), e, "application/json", {}, !0, t);

          case 2:
            return _context6.abrupt("return", _context6.sent.results.map(transformShape$2));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchBoundaries(_x13, _x14) {
    return _ref10.apply(this, arguments);
  };
}(),
    fetchExtent = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, t) {
    var r, i;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            e.spatialReference = "wgs84";
            _context7.next = 3;
            return Request.post(Ze("boundary/extent"), e, "application/json", {}, !0, t);

          case 3:
            r = _context7.sent;
            i = L.geometryFromGeoJson(r, L.getSpatialReference(4326));
            return _context7.abrupt("return", null == i ? void 0 : i.extent.clone().expand(1.5));

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function fetchExtent(_x15, _x16) {
    return _ref11.apply(this, arguments);
  };
}(),
    fetchFieldBoundaryGuids = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, t) {
    var r, i, s, a, n, o, u, l;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            a = FieldBoundaryEndpoint.baseQueryString(null, null, e.isActive, Ke), n = null != e.customerGuid ? null === (r = e.customerGuid) || void 0 === r ? void 0 : r.filter(Boolean) : [], o = null != e.farmName ? null === (i = e.farmName) || void 0 === i ? void 0 : i.filter(Boolean) : [], u = null != e.fieldGuid ? null === (s = e.fieldGuid) || void 0 === s ? void 0 : s.filter(Boolean) : [];

            if (!(n.length > 0 && a.append("customer", n), o.length > 0 && a.append("farm", o), u.length > 0 && a.append("field", u), e.returnEmptyArrayIfNoFilters && 0 === n.length && 0 === o.length && 0 === u.length)) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return", Promise.resolve([]));

          case 3:
            _context8.next = 5;
            return Request.get(Ze("boundary/id", a.toString()), [], e.userGuid, {}, t);

          case 5:
            l = _context8.sent;
            return _context8.abrupt("return", (null == l ? void 0 : l.length) > 0 ? l : []);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function fetchFieldBoundaryGuids(_x17, _x18) {
    return _ref12.apply(this, arguments);
  };
}(),
    fieldBoundaryToGraphic = function fieldBoundaryToGraphic(e) {
  return L.toFeature(e, "shape", !1, ["shape", "centroid"]);
},
    st = {
  customerGuid: "customerGuid",
  farmName: "farm",
  fieldName: "field",
  importFieldBoundaryGuid: "importFieldBoundaryGuid",
  importFileGuid: "importFileGuid"
};

var ImportFieldBoundaryEndpoint = /*#__PURE__*/function () {
  function ImportFieldBoundaryEndpoint() {
    _classCallCheck(this, ImportFieldBoundaryEndpoint);
  }

  _createClass(ImportFieldBoundaryEndpoint, null, [{
    key: "fetchByImportBoundaryGuid",
    value: function fetchByImportBoundaryGuid(e) {
      return fetchByList({
        endpoint: ImportFieldBoundaryEndpoint.descriptor,
        filterName: "importBoundary",
        limit: 100
      }, ImportFieldBoundaryEndpoint.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return ImportFieldBoundaryEndpoint;
}();

ImportFieldBoundaryEndpoint.descriptor = {
  name: "importBoundary",
  aggregateUrl: Ze,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformShape$2);
  }
};

var at = ImportFieldBoundaryEndpoint.fetchByImportBoundaryGuid,
    importFieldBoundaryToGraphic = function importFieldBoundaryToGraphic(e) {
  return L.toFeature(e, "shape");
},
    nt = Object.freeze({
  __proto__: null,
  GET_AGVANCE_FIELD_LIST: Je,
  GET_AGVANCE_FIELD_CLASSIFICATION_LIST: Xe,
  GET_AGVANCE_FIELD_DATA: et,
  COMBINE_FIELDS_URL: tt,
  spatialReference: 102100,
  apiSpatialReference: 4326,
  combineFields: function combineFields(e, t) {
    return Request.post(tt, {
      UserGuid: e,
      Model: t
    });
  },
  ignoreFarmsMatching: function ignoreFarmsMatching(e, t, r) {
    return Request.post(apiUrl("ImportGrooming/IgnoreFarmsMatching"), {
      UserGuid: e,
      Model: {
        ImportFileGuidList: t,
        IgnoreFarm: r
      }
    });
  },
  getField: function getField(e) {
    return Request.get(Ze(e));
  },
  getFields: function getFields(e) {
    var t = new QueryString();
    return null != e.customerGuid && t.append("customerGuid", e.customerGuid), null != e.fieldGuids && t.append("field", e.fieldGuids), Request.get(Ze("", t.toString()));
  },
  getCLUBoundary: function getCLUBoundary(e) {
    var t = new QueryString();
    return t.append("x", e.x.toString()), t.append("y", e.y.toString()), Request.get(Ze("cluBoundary", t.toString()));
  },
  saveField: function saveField(e, t) {
    var i = function (e, t) {
      var i;
      var s = e.fieldBoundary.fieldBoundaryPolygons.map(function (e) {
        return {
          fieldBoundaryPolygonGuid: null == e.fieldBoundaryPolygonGuid || "" === e.fieldBoundaryPolygonGuid ? r() : e.fieldBoundaryPolygonGuid,
          importFieldBoundaryGuids: e.importFieldBoundaryGuids,
          fieldGuidsToCombine: e.fieldGuidsToCombine,
          shapes: e.shapes
        };
      }),
          a = {
        fieldBoundaryGuid: null == e.fieldBoundary.fieldBoundaryGuid || "" === e.fieldBoundary.fieldBoundaryGuid ? r() : e.fieldBoundary.fieldBoundaryGuid,
        calculatedArea: e.fieldBoundary.calculatedArea,
        stateAbbr: e.fieldBoundary.stateAbbr,
        county: e.fieldBoundary.county,
        township: e.fieldBoundary.township,
        range: e.fieldBoundary.range,
        section: e.fieldBoundary.section,
        meridian: null,
        watershedNum: e.fieldBoundary.watershedNum,
        watershedName: e.fieldBoundary.watershedName,
        soilSeries: e.fieldBoundary.soilSeries,
        soilTexture: e.fieldBoundary.soilTexture,
        importFileGuid: assignNullableGuid(e.importFileGuid),
        polygons: s
      },
          n = e.fieldCropYieldList.map(function (e) {
        return {
          fieldCropYieldGuid: null == e.fieldCropYieldGuid || "" === e.fieldCropYieldGuid ? r() : e.fieldCropYieldGuid,
          fieldGuid: assignNullableGuid(e.fieldGuid),
          cropGuid: assignNullableGuid(e.cropGuid),
          cropPurposeGuid: assignNullableGuid(e.cropPurposeGuid),
          averageYield: e.averageYield,
          yieldUnitGuid: assignNullableGuid(e.yieldUnitGuid),
          countyTYield: e.countyTYield
        };
      }),
          o = e.fieldLeaseList.map(function (e) {
        return {
          fieldLeaseGuid: null == e.fieldLeaseGuid || "" === e.fieldLeaseGuid ? r() : e.fieldLeaseGuid,
          fieldGuid: assignNullableGuid(e.fieldGuid),
          landlordName: e.landlordName,
          parentProductTypeGuid: assignNullableGuid(e.parentProductTypeGuid),
          productTypeSharePercent: e.productTypeSharePercent,
          cropSharePercent: e.cropSharePercent
        };
      });
      return {
        acres: e.acres,
        active: e.activeYn,
        agvanceAutoMapField: null !== (i = e.agvanceAutoMapField) && void 0 !== i && i,
        agvanceBillableArea: Number(e.agvanceBillableArea) || null,
        agvanceCustomerGuid: assignNullableGuid(e.agvanceCustomerGuid),
        agvanceFieldGuid: assignNullableGuid(e.agvanceFieldGuid),
        agvanceFieldId: e.agvanceFieldId,
        agvanceFieldOrgLevelGuid: assignNullableGuid(e.agvanceFieldOrgLevelGuid),
        apn: e.apn,
        boundary: a,
        brandOrganizationGuid: assignNullableGuid(e.brandOrganizationGuid),
        certifiedOrganic: e.certifiedOrganic,
        classifications: e.classifications,
        cluAcres: "" === e.cluAcres ? null : e.cluAcres,
        cluId: "" === e.cluId ? null : e.cluId,
        cropClassNameGuid: assignNullableGuid(e.cropClassNameGuid),
        cropGuid: assignNullableGuid(e.cropGuid),
        cropPlantingDate: e.cropPlantingDate,
        cropPurposeGuid: assignNullableGuid(e.cropPurposeGuid),
        cropYields: n,
        customerEnrolled: e.customerEnrolled,
        customerGuid: e.customerGuid,
        customerName: e.customerName,
        directions: e.directions,
        drainageTile: e.drainageTile,
        events: e.events,
        farmName: e.farmName,
        fieldNotes: e.fieldNotes,
        fsaAcres: "" === e.fsaAcres ? null : e.fsaAcres,
        fsaFarmNum: e.fsaFarmNum,
        fsaFieldNum: e.fsaFieldNum,
        fsaTractNum: e.fsaTractNum,
        highRiskLandYn: e.highRiskLandYn,
        insuranceNum: e.insuranceNum,
        insurancePolicyTypeGuid: assignNullableGuid(e.insurancePolicyTypeGuid),
        irrigated: "" === e.irrigated ? null : e.irrigated,
        irrigationTypeGuid: assignNullableGuid(e.irrigationTypeGuid),
        landOwnershipTypeGuid: assignNullableGuid(e.landOwnershipTypeGuid),
        leases: o,
        leaseExpireDate: e.leaseExpireDate,
        legalDescription: e.legalDescription,
        modifiedDate: e.modifiedDate,
        name: e.fieldName,
        recs: e.recs,
        resurfaceEventResult: e.resurfaceEventResult,
        userGuid: t,
        varietyHybridGuid: assignNullableGuid(e.varietyHybridGuid)
      };
    }(t, e),
        s = null == t.fieldGuid || "" === t.fieldGuid ? r() : t.fieldGuid,
        a = Ze(s);

    return Request.put(a, i);
  },
  updateFieldDetails: function updateFieldDetails(e, t) {
    var r = {
      "user-guid": t
    };
    return Request.patch(Ze("", null), e, "application/json", r);
  },
  deactivateField: function deactivateField(e, t) {
    return Request.delete(apiUrl("SetupField/FieldDeactivate"), {
      UserGuid: e,
      Model: t
    });
  },
  deactivateFields: function deactivateFields(e, t) {
    return Request.delete(apiUrl("SetupField/FieldsDeactivate"), {
      UserGuid: e,
      Model: t
    });
  },
  deactivateFieldsIgnoreAgvance: function deactivateFieldsIgnoreAgvance(e, t) {
    return Request.post(apiUrl("SetupField/FieldsDeactivateIgnoreAgvance"), {
      UserGuid: e,
      Model: t
    });
  },
  exportFieldDetails: function exportFieldDetails(e, t) {
    var r = {
      "user-guid": e
    },
        i = Ze("export/details");
    return Request.post(i, {
      fieldGuids: t
    }, "application/json", r);
  },
  activateField: function activateField(e, t) {
    return Request.put(apiUrl("SetupField/FieldActivate"), {
      UserGuid: e,
      Model: t
    });
  },
  getAgvanceCustomerList: function getAgvanceCustomerList(e, t) {
    return getCustomer(t, {
      "user-guid": e
    });
  },
  getAgvanceFieldData: function getAgvanceFieldData(e, t) {
    return Request.post(et, {
      UserGuid: e,
      Model: t
    });
  },
  getFullFieldRecords: function getFullFieldRecords(e, t) {
    var r = new QueryString();
    return r.append("field", t), Request.get(Ze("", r.toString()));
  },
  fieldBoundaryEsriFields: [{
    name: "shape",
    type: "esriFieldTypeGeometry"
  }, {
    name: "calculatedArea",
    type: "esriFieldTypeDouble"
  }, {
    name: "stateAbbr",
    type: "esriFieldTypeString"
  }, {
    name: "county",
    type: "esriFieldTypeString"
  }, {
    name: "township",
    type: "esriFieldTypeString"
  }, {
    name: "range",
    type: "esriFieldTypeString"
  }, {
    name: "section",
    type: "esriFieldTypeString"
  }, {
    name: "watershedNum",
    type: "esriFieldTypeString"
  }, {
    name: "watershedName",
    type: "esriFieldTypeString"
  }, {
    name: "activeYn",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "name",
    type: "esriFieldTypeString"
  }, {
    name: "customerName",
    type: "esriFieldTypeString"
  }, {
    name: "fieldBoundaryGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "fieldGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "customerGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "fieldBoundaryPolygonGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "farmName",
    type: "esriFieldTypeString"
  }],
  mappedFieldBoundaryFields: it,
  fetchFieldBoundariesByCurrentUserGuidAndExtent: fetchFieldBoundariesByCurrentUserGuidAndExtent,
  fetchFieldBoundariesByCustomerGuid: fetchFieldBoundariesByCustomerGuid,
  fetchFieldBoundariesByFieldGuid: fetchFieldBoundariesByFieldGuid,
  fetchFieldBoundariesByBoundaryGuid: fetchFieldBoundariesByBoundaryGuid,
  fetchExtent: fetchExtent,
  fetchFieldBoundaryGuids: fetchFieldBoundaryGuids,
  fieldBoundaryToGraphic: fieldBoundaryToGraphic,
  fieldCentroidToGraphic: function fieldCentroidToGraphic(e) {
    return L.toFeature(e, "centroid", !1, ["shape", "centroid"]);
  },
  importFieldBoundaryEsriFields: [{
    name: "objectId",
    type: "esriFieldTypeOID"
  }, {
    name: "shape",
    type: "esriFieldTypeGeometry"
  }, {
    name: "importFieldBoundaryGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "importFileGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "customer",
    type: "esriFieldTypeString"
  }, {
    name: "customerGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "farm",
    type: "esriFieldTypeString"
  }, {
    name: "field",
    type: "esriFieldTypeString"
  }, {
    name: "fieldGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "acres",
    type: "esriFieldTypeString"
  }, {
    name: "importedYn",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "agvanceFieldGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "agvanceFieldOrgLevelGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "agvanceCustomerGuid",
    type: "esriFieldTypeGUID"
  }],
  mappedImportFieldBoundaryFields: st,
  fetchImportFieldBoundariesByImportBoundaryGuid: at,
  importFieldBoundaryToGraphic: importFieldBoundaryToGraphic,
  fetchResurfaceEventList: function fetchResurfaceEventList(e, t) {
    return Promise.reject("This function is deprecated. Use 'EventAPI.fetchResurfaceEventList' instead.");
  }
});

var ExportRecRequest = /*#__PURE__*/function () {
  function ExportRecRequest(e) {
    _classCallCheck(this, ExportRecRequest);

    this.controllerFileTypeGuid = null, this.controllerTypeGuid = null, this.fileNameFormatGuid = null, this.loadsheetYn = !0, this.mergeControllerFilesYn = !1, this.multiProductYn = !1, this.routingMapYn = !1, this.sendTotalsToAgvanceYn = !1, this.userExportRecPreferences = null, this.recGeneralGuidList = e;
  }

  _createClass(ExportRecRequest, [{
    key: "setProps",
    value: function setProps(e) {
      Object.assign(this, e);
    }
  }]);

  return ExportRecRequest;
}();

var ProductRecImportFileMatch = function ProductRecImportFileMatch() {
  _classCallCheck(this, ProductRecImportFileMatch);
};

var ProductRecInvalidFile = function ProductRecInvalidFile() {
  _classCallCheck(this, ProductRecInvalidFile);
};

var ImportProductRecFieldMatchingResponse = function ImportProductRecFieldMatchingResponse() {
  _classCallCheck(this, ImportProductRecFieldMatchingResponse);
};

var ImportProductRecFieldMatchingRequest = function ImportProductRecFieldMatchingRequest() {
  _classCallCheck(this, ImportProductRecFieldMatchingRequest);
};

var ot = Object.freeze({
  __proto__: null,
  ExportRecRequest: ExportRecRequest,
  ProductRecImportFileMatch: ProductRecImportFileMatch,
  ProductRecInvalidFile: ProductRecInvalidFile,
  ImportProductRecFieldMatchingResponse: ImportProductRecFieldMatchingResponse,
  ImportProductRecFieldMatchingRequest: ImportProductRecFieldMatchingRequest
}),
    ut = aggregateUrlGenerator("search", "v1.0"),
    lt = ot,
    getImportDataFromS3 = function getImportDataFromS3(e, t) {
  return Request.post(apiUrl("ImportGrooming/GetImportDataFromS3"), {
    UserGuid: e,
    Model: {
      importFileGuidList: t
    }
  });
},
    getValidEventIds = function getValidEventIds(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
  var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var n = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Boolean;
  var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
  return Request.post(apiUrl("ImportGrooming/GetValidEventIds"), {
    UserGuid: e,
    Model: {
      customerGuid: r,
      farmName: i,
      fieldGuid: s,
      searchString: t,
      importFileGuidList: a,
      allEventIds: n,
      enrollmentLock: o
    }
  });
},
    dt = Object.freeze({
  __proto__: null,
  models: lt,
  addImportFileList: function addImportFileList(e, t) {
    return Request.post(apiUrl("ImportFile/AddImportFileList"), {
      UserGuid: e,
      Model: t
    });
  },
  importFileUploadsComplete: function importFileUploadsComplete(e, t) {
    return Request.post(apiUrl("FileUpload/UploadsComplete"), {
      UserGuid: e,
      Model: t
    });
  },
  addImportProductMix: function addImportProductMix(e, t) {
    return Request.post(apiUrl("ImportGrooming/AddImportProductMix"), {
      UserGuid: e,
      Model: t
    });
  },
  cancelImportFileCreateEvent: function cancelImportFileCreateEvent(e, t) {
    return Request.post(apiUrl("ImportGrooming/CancelImportFileCreateEvent"), {
      UserGuid: e,
      Model: t
    });
  },
  createFieldBoundary: function createFieldBoundary(e, t) {
    return Request.post(apiUrl("ImportGrooming/CreateFieldBoundary"), {
      UserGuid: e,
      Model: t
    });
  },
  createImportAgEvent: function createImportAgEvent(e, t) {
    return Request.post(apiUrl("Grooming/CreateEventsFromProposedEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  addFieldBoundaryImportFile: function addFieldBoundaryImportFile(e, t) {
    return Request.post(apiUrl("ImportFile/AddFieldBoundaryImportFile"), {
      UserGuid: e,
      Model: t
    });
  },
  addZoneImportFile: function addZoneImportFile(e, t) {
    return Request.post(apiUrl("ImportFile/AddZoneImportFile"), {
      UserGuid: e,
      Model: t
    });
  },
  deleteUploadedFile: function deleteUploadedFile(e, t) {
    return Request.delete(apiUrl("FileUpload/DeleteUploadedFile"), {
      UserGuid: e,
      Model: t
    });
  },
  exportEventData: function exportEventData(e, t) {
    return Request.post(apiUrl("Export/ExportEventData"), {
      UserGuid: e,
      Model: t
    });
  },
  exportSurfaceData: function exportSurfaceData(e, t) {
    return Request.post(apiUrl("Export/ExportSurfaceData"), {
      UserGuid: e,
      Model: t
    });
  },
  exportFieldBoundary: function exportFieldBoundary(e, t) {
    return Request.post(apiUrl("Export/ExportFieldBoundary"), {
      UserGuid: e,
      Model: t
    });
  },
  exportControllerFiles: function exportControllerFiles(e, t) {
    return Request.post(apiUrl("Export/ExportControllerFiles"), {
      UserGuid: e,
      Model: t
    });
  },
  exportSamplingPoints: function exportSamplingPoints(e, t) {
    return Request.post(apiUrl("Export/ExportSoilSamplePoints"), {
      UserGuid: e,
      Model: t
    });
  },
  getErrorDetails: function getErrorDetails(e, t, r) {
    return Request.post(apiUrl("Logs/GetErrorDetails"), {
      UserGuid: e,
      Model: {
        logType: t,
        correlationId: r
      }
    });
  },
  getControllerFileTypeList: function getControllerFileTypeList(e, t) {
    return Request.post(apiUrl("Export/GetControllerFileTypeList"), {
      Model: {
        ControllerType: t,
        RecGuidList: e
      }
    });
  },
  getControllerTypeList: function getControllerTypeList(e) {
    return Request.post(apiUrl("Export/GetControllerTypeList"), {
      UserGuid: e
    });
  },
  getFileNameFormatList: function getFileNameFormatList(e) {
    return Request.post(apiUrl("Export/GetFileNameFormatList"), {
      UserGuid: e
    });
  },
  getImportDataFromS3: getImportDataFromS3,
  getImportEventPreview: function getImportEventPreview(e, t) {
    return Request.post(apiUrl("Grooming/GetProposedEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  getImportFieldMatching: function getImportFieldMatching(e, t) {
    return Request.post(apiUrl("Grooming/GetImportFieldMatching"), {
      UserGuid: e,
      Model: t
    });
  },
  getImportFieldStrips: function getImportFieldStrips(e, t) {
    return Request.post(apiUrl("Grooming/GetImportFieldStrips"), {
      UserGuid: e,
      Model: t
    });
  },
  getImportFilterLists: function getImportFilterLists(e, t) {
    return Request.post(apiUrl("Grooming/GetImportFilterLists"), {
      UserGuid: e,
      Model: t
    });
  },
  getImageryLayers: function getImageryLayers(e, t) {
    return Request.post(apiUrl("ImportGrooming/GetImageryLayers"), {
      UserGuid: e,
      Model: t
    });
  },
  getImportS3PreSignedUrl: function getImportS3PreSignedUrl(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "multipart/form-data";
    return Request.post(apiUrl("FileUpload/GenerateImportS3PreSignedURL"), {
      UserGuid: e,
      groupGuid: t,
      filename: r,
      contentType: i
    });
  },
  getImportStatusList: function getImportStatusList(e) {
    return Request.post(apiUrl("SamplingImport/GetImportStatusList"), {
      UserGuid: e
    });
  },
  getImportTypeList: function getImportTypeList(e) {
    return Request.post(apiUrl("Template/GetImportTypeList"), {
      UserGuid: e,
      Model: {}
    });
  },
  getIsOnsiteTelematicsUser: function getIsOnsiteTelematicsUser(e) {
    return Request.post(apiUrl("OnSiteMonitorFile/GetIsOnsiteTelematicsUser"), {
      UserGuid: e
    });
  },
  getOnsiteEventDownloadCount: function getOnsiteEventDownloadCount(e) {
    return Request.post(apiUrl("OnSiteMonitorFile/GetOnsiteEventDownloadCount"), {
      UserGuid: e
    });
  },
  getOnsiteFileList: function getOnsiteFileList(e, t) {
    return Request.post(apiUrl("OnSiteMonitorFile/GetOnsiteFileList"), {
      UserGuid: e
    });
  },
  getOrderedImportTypeList: function getOrderedImportTypeList(e) {
    return Request.post(apiUrl("Template/GetOrderedImportTypeList"), {
      UserGuid: e
    });
  },
  getProjectedFeaturesFromUploadedShapefile: function getProjectedFeaturesFromUploadedShapefile(e, t, r, i, s) {
    return Request.post(apiUrl("FileUpload/GetProjectedFeaturesFromUploadedShapefile"), {
      UserGuid: e,
      groupGuid: t,
      filename: r,
      importFileGuid: i,
      outWkid: s
    });
  },
  getSamplePointsByEventIds: function getSamplePointsByEventIds(e, t) {
    return Request.post(apiUrl("ImportGrooming/GetSamplePointsByEventIds"), {
      UserGuid: e,
      Model: t
    });
  },
  getSamplePointsByFile: function getSamplePointsByFile(e, t) {
    return Request.post(apiUrl("ImportGrooming/GetSamplePointsByFile"), {
      UserGuid: e,
      Model: t
    });
  },
  getSoilSampleResults: function getSoilSampleResults(e, t) {
    return Request.post(apiUrl("SamplingImport/GetSoilSampleResults"), {
      UserGuid: e,
      Model: t
    });
  },
  getTissueSampleResults: function getTissueSampleResults(e, t) {
    return Request.post(apiUrl("SamplingImport/GetTissueSampleResults"), {
      UserGuid: e,
      Model: t
    });
  },
  getTemplateList: function getTemplateList(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    return Request.post(apiUrl("Template/GetTemplateList"), {
      UserGuid: e,
      Model: {
        importTypeGuid: t,
        editableOnly: r
      }
    });
  },
  getImportTypes: function getImportTypes(e) {
    return Request.post(ut("import/type"), e);
  },
  getImportTemplates: function getImportTemplates(e) {
    return Request.post(ut("import/template"), e);
  },
  getUploadedFiles: function getUploadedFiles(e) {
    return Request.post(ut("import/uploaded-file"), e);
  },
  getValidDeleteStatusList: function getValidDeleteStatusList() {
    return Request.post(apiUrl("ImportFile/GetValidDeleteStatusList"));
  },
  getUserCropImportPreferences: function getUserCropImportPreferences(e, t, r) {
    return Request.post(apiUrl("User/GetUserCropImportPreferences"), {
      UserGuid: e,
      Model: {
        cropGuid: t,
        yieldIaGuid: r
      }
    });
  },
  getUserExportPreferences: function getUserExportPreferences(e) {
    return Request.post(apiUrl("Export/GetUserExportPreferences"), {
      UserGuid: e
    });
  },
  getValidEventIds: getValidEventIds,
  processShpFileImport: function processShpFileImport(e, t) {
    return Request.post(apiUrl("FileUpload/ProcessShpFileImport"), {
      UserGuid: e,
      Model: t
    });
  },
  searchUsers: function searchUsers(e, t) {
    return Request.post(apiUrl("User/SearchUser"), {
      UserGuid: e,
      Model: t
    });
  },
  updateCrop: function updateCrop(e, t) {
    return Request.post(apiUrl("ImportGrooming/UpdateCrop"), {
      UserGuid: e,
      Model: t
    });
  },
  updateCroppingSeason: function updateCroppingSeason(e, t) {
    return Request.post(apiUrl("ImportGrooming/UpdateCroppingSeason"), {
      UserGuid: e,
      Model: t
    });
  },
  updateEventId: function updateEventId(e, t, r, i) {
    return Request.post(apiUrl("ImportGrooming/UpdateEventId"), {
      UserGuid: e,
      Model: {
        importFileGuidList: t,
        oldEventId: r,
        newEventId: i
      }
    });
  },
  updateImportBoundary: function updateImportBoundary(e, t) {
    return Request.post(apiUrl("ImportGrooming/ImportBoundaryUpdate"), {
      UserGuid: e,
      Model: t
    });
  },
  updateMachine: function updateMachine(e, t) {
    return Request.post(apiUrl("ImportGrooming/UpdateMachine"), {
      UserGuid: e,
      Model: t
    });
  },
  updateProductMix: function updateProductMix(e, t) {
    return Request.post(apiUrl("ImportGrooming/UpdateProductMix"), {
      UserGuid: e,
      Model: t
    });
  },
  updateUserCropImportPreferences: function updateUserCropImportPreferences(e, t, r, i, s) {
    return Request.post(apiUrl("User/UpdateUserCropImportPreferences"), {
      UserGuid: e,
      Model: {
        cropGuid: t,
        yieldIaGuid: r,
        averageTestWeight: i,
        averageUnitWeight: s
      }
    });
  },
  updateImageryLayers: function updateImageryLayers(e, t) {
    return Request.post(apiUrl("ImportGrooming/UpdateImageryLayers"), {
      UserGuid: e,
      Model: t
    });
  },
  updateUserImportPreferences: function updateUserImportPreferences(e, t, r, i) {
    return Request.post(apiUrl("Template/UpdateUserImportPreferences"), {
      UserGuid: e,
      Model: {
        importTypeGuid: t,
        importTemplateGuid: r,
        importFileGuid: null,
        isSelected: i
      }
    });
  },
  validateImportAgEvent: function validateImportAgEvent(e, t) {
    return Request.post(apiUrl("Grooming/ValidateAndCreateProposedEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  getImportProductRecMatchingFields: function getImportProductRecMatchingFields(e, t) {
    return Request.post(apiUrl("ImportFile/GetImportProductRecMatchingFields"), {
      UserGuid: e,
      Model: t
    });
  },
  getRxFileImportTemplateAndImportType: function getRxFileImportTemplateAndImportType() {
    return Request.get(apiUrl("Template/GetRxFileImportTemplateAndImportType"));
  },
  ExportRecRequest: ExportRecRequest,
  ProductRecImportFileMatch: ProductRecImportFileMatch,
  ProductRecInvalidFile: ProductRecInvalidFile,
  ImportProductRecFieldMatchingResponse: ImportProductRecFieldMatchingResponse,
  ImportProductRecFieldMatchingRequest: ImportProductRecFieldMatchingRequest
}),
    pt = apiUrl("AgBytes/GetTissueGrowthStageOrderAgBytesList"),
    ct = Object.freeze({
  __proto__: null,
  REQUEST_TISSUE_GROWTH_STAGE_ORDER: pt
}),
    mt = apiUrl("SetupOrgLevel/AddOrgLevel"),
    yt = apiUrl("SetupOrgLevel/GetAutoSearchList"),
    gt = apiUrl("SetupOrgLevel/DeleteOrgLevel"),
    Gt = apiUrl("SetupOrgType/GetActiveOrgTypeName"),
    Rt = apiUrl("SetupOrgLevel/GetAffiliationsParentList"),
    Et = apiUrl("SetupCompany/GetCompanyRecordGrid"),
    St = apiUrl("SetupOrgType/GetHierarchyFilterListWithSearch"),
    Tt = apiUrl("SetupOrgLevel/GetOrgLevel"),
    At = apiUrl("SetupOrgLevel/GetOrgLevelChildren"),
    _t = apiUrl("SetupOrgLevel/MoveLocation"),
    Lt = apiUrl("SetupOrgLevel/GetOrgLevelListWithParents"),
    ft = apiUrl("SetupOrgLevel/GetOrgLevelListWithParentsGuid"),
    Ut = apiUrl("SetupOrgLevel/UpdateOrgLevel"),
    Pt = apiUrl("SetupOrgLevel/GetOrgLevelWithAgvanceDatabaseId"),
    It = apiUrl("SetupOrgLevel/GetLocationList"),
    vt = Object.freeze({
  __proto__: null,
  ADD_ORG_LEVEL: mt,
  AUTO_SEARCH_URL: yt,
  DELETE: gt,
  GET_ACTIVE_ORG_TYPE_NAME: Gt,
  GET_AFFILIATIONS_PARENT_LIST: Rt,
  GET_COMPANY_RECORD_GRID: Et,
  GET_HIERARCHY_FILTER_LIST_WITH_SEARCH: St,
  GET_ORG_LEVEL: Tt,
  GET_ORG_LEVEL_CHILDREN: At,
  MOVE_LOCATION_URL: _t,
  REQUEST_ORG_LEVEL_WITH_PARENTS: Lt,
  REQUEST_ORG_LEVEL_WITH_PARENTS_GUID: ft,
  UPDATE_ORG_LEVEL: Ut,
  GET_ORG_LEVEL_WITH_AGVANCE_DATABASE_ID: Pt,
  GET_LOCATION_LIST: It,
  addOrgLevel: function addOrgLevel(e) {
    return Request.post(mt, e);
  },
  updateOrgLevel: function updateOrgLevel(e) {
    return Request.post(Ut, e);
  },
  getOrgLevel: function getOrgLevel(e) {
    return Request.post(Tt, e);
  },
  getActiveOrgTypeName: function getActiveOrgTypeName(e) {
    return Request.post(Gt, e);
  },
  getOrgLevelList: function getOrgLevelList(e) {
    return Request.post(Lt, {
      UserGuid: e,
      Model: "_"
    });
  }
}),
    ht = apiUrl("AgBytes/GetImportAttributeAgBytesList"),
    Ot = Object.freeze({
  __proto__: null,
  REQUEST_IMPORT_ATTRIBUTE: ht
}),
    Ft = apiUrl("ImportDataFilter/GetImportDataFilterValues"),
    Ct = apiUrl("ImportDataFilter/SaveImportDataFilterValues"),
    Mt = Object.freeze({
  __proto__: null,
  getImportDataFilterValues: function getImportDataFilterValues(e) {
    return Request.post(Ft, e);
  },
  saveImportDataFilterValues: function saveImportDataFilterValues(e) {
    return Request.post(Ct, e);
  }
}),
    Dt = aggregateUrlGenerator("layer", "v1.0"),
    transformShape$1 = function transformShape$1(e) {
  return L.geometryFromApiInplace(e, "shape", L.getSpatialReference(102100));
},
    Nt = {
  class: "Class",
  agEventGeneralGuid: "AgEventGeneralGuid",
  agEventTransactionTypeGuid: "AgEventTransactionTypeGuid",
  importAttributeGuid: "ImportAttributeGuid",
  surfaceGuid: "SurfaceGuid",
  surfaceRendererGuid: "SurfaceRendererGuid",
  surfaceRendererVectorGuid: "SurfaceRendererVectorGuid",
  surfaceType: "SurfaceType",
  surfaceTypeGuid: "SurfaceTypeGuid"
},
    qt = {
  STATE: "state",
  TOWNSHIP: "township",
  RANGE: "range",
  SECTION: "section"
},
    bt = L.config.services.sampleSites.layerDefinition;

var SurfacePolygonEndpoint = /*#__PURE__*/function () {
  function SurfacePolygonEndpoint() {
    _classCallCheck(this, SurfacePolygonEndpoint);
  }

  _createClass(SurfacePolygonEndpoint, null, [{
    key: "fetch",
    value: function fetch(e) {
      return fetchByList({
        endpoint: SurfacePolygonEndpoint.descriptor,
        filterName: "surfaceRenderer",
        limit: 100
      }, SurfacePolygonEndpoint.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return SurfacePolygonEndpoint;
}();

SurfacePolygonEndpoint.descriptor = {
  name: "surfacePolygon",
  aggregateUrl: Dt,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformShape$1);
  }
};

var fetchSurfacePolygons = function fetchSurfacePolygons(e) {
  if (!e) return Promise.resolve([]);
  var t = Array.isArray(e) ? e.filter(function (e) {
    return e;
  }) : [e];
  return SurfacePolygonEndpoint.fetch(t);
},
    surfacePolygonToGraphic = function surfacePolygonToGraphic(e) {
  return L.toFeature(e, "shape", !0);
},
    getFieldBoundaryCentroids = function getFieldBoundaryCentroids(e) {
  return Request.post(apiUrl("Layers/GetFieldBoundaryCentroids"), {
    UserGuid: e
  });
},
    getCoverageSurfaceMapImage = function getCoverageSurfaceMapImage(e, t) {
  return Request.post(apiUrl("Layers/getSurfaceImage"), {
    UserGuid: e,
    Model: t
  });
},
    getColorRamp = function getColorRamp(_ref13) {
  var e = _ref13.colorRampName,
      t = _ref13.numberOfClasses,
      r = _ref13.includeZeroClass;
  return Request.post(apiUrl("Layers/GetColorRamp"), {
    Model: {
      ColorRampName: e,
      NumberOfClasses: t,
      IncludeZeroClass: r
    }
  });
},
    getSurfaceEventLayerPoints = function getSurfaceEventLayerPoints(e, t, r) {
  var i = t.agEventGeneralGuid,
      s = t.agEventTransactionTypeGuid,
      a = t.importAttributeGuid;
  return Request.post(apiUrl("Layers/GetSurfaceEventLayerPoints"), {
    UserGuid: e,
    Model: {
      agEventGeneralGuid: i,
      agEventTransactionTypeGuid: s,
      fieldGuid: r,
      importAttributeGuid: a
    }
  });
},
    Bt = Object.freeze({
  __proto__: null,
  surfacePolygonEsriFields: [{
    name: "Class",
    type: "esriFieldTypeString"
  }, {
    name: "AgEventGeneralGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "AgEventTransactionTypeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "ImportAttributeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SurfaceGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SurfaceRendererGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SurfaceRendererVectorGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SurfaceType",
    type: "esriFieldTypeString"
  }, {
    name: "SurfaceTypeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedSurfacePolygonFields: Nt,
  PLSSTypes: qt,
  sampleSiteLayerDefinitions: bt,
  fetchSurfacePolygons: fetchSurfacePolygons,
  surfacePolygonToGraphic: surfacePolygonToGraphic,
  deleteAnalysisLayer: function deleteAnalysisLayer(e, t) {
    return Request.post(apiUrl("AnalysisLayers/DeleteAnalysisLayer"), {
      Model: e,
      UserGuid: t
    });
  },
  deleteAnalysisLayerBatch: function deleteAnalysisLayerBatch(e, t) {
    return Request.post(apiUrl("AnalysisLayers/DeleteAnalysisLayerBatch"), {
      Model: e,
      UserGuid: t
    });
  },
  deleteImageryLayer: function deleteImageryLayer(e, t) {
    return Request.post(apiUrl("Layers/DeleteImageryLayer"), {
      Model: e,
      UserGuid: t
    });
  },
  getAnalysisLayer: function getAnalysisLayer(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetAnalysisLayer"), {
      Model: e,
      UserGuid: t
    });
  },
  getAnalysisLayerTypes: function getAnalysisLayerTypes(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetAnalysisLayerTypes"), {
      Model: e,
      UserGuid: t
    });
  },
  getAvailableLayersByFieldGuid: function getAvailableLayersByFieldGuid(e, t) {
    return Request.post(apiUrl("Layers/GetAvailableLayersByFieldGuid"), {
      UserGuid: e,
      Model: t
    });
  },
  getDefaultAttributeGuid: function getDefaultAttributeGuid(e, _ref14) {
    var t = _ref14.AgEventGeneralGuid,
        r = _ref14.AgEventTransactionTypeGuid,
        i = _ref14.isManual;
    return Request.post(apiUrl("Layers/GetDefaultAttributeGuid"), {
      UserGuid: e,
      Model: {
        AgEventGeneralGuid: t,
        AgEventTransactionTypeGuid: r,
        isManual: i
      }
    });
  },
  getDefaultSymbology: function getDefaultSymbology(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return Request.post(apiUrl("Layers/GetDefaultSymbology"), {
      UserGuid: e,
      Model: {
        AgEventGeneralGuid: t,
        ImportAttributeGuid: r,
        NutrientGuidFromEquationRec: i
      }
    });
  },
  getDefaultSurfaceTypeGuid: function getDefaultSurfaceTypeGuid(e, t, r, i) {
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
    return Request.post(apiUrl("Layers/GetDefaultSurfaceTypeGuid"), {
      UserGuid: e,
      Model: {
        agEventTransactionTypeGuid: t,
        systemAttributeGuid: r,
        customerGuid: i,
        isFromEquationRec: s
      }
    });
  },
  getFieldBoundaryCentroids: getFieldBoundaryCentroids,
  getFieldBoundariesByExtent: function getFieldBoundariesByExtent(e, t) {
    return 102100 === t.spatialReference.wkid && (t = L.webMercatorToGeographic(t)), Request.post(apiUrl("Layers/GetFieldBoundariesByExtent"), {
      UserGuid: e,
      Model: JSON.stringify(t)
    });
  },
  getImageryLayer: function getImageryLayer(e, t) {
    return Request.post(apiUrl("Layers/GetImageryLayer"), {
      UserGuid: e,
      Model: t
    });
  },
  getImageryTileBucketName: function getImageryTileBucketName(e) {
    return Request.post(apiUrl("Layers/GetImageryTileBucketName"), {
      UserGuid: e
    });
  },
  getLayerFilterOptions: function getLayerFilterOptions(e, t, r) {
    return Request.post(apiUrl("Layers/GetLayerFilterOptions"), {
      FieldGuids: e,
      UserGuid: t,
      Enrolled: r
    });
  },
  getManualSymbologyOptions: function getManualSymbologyOptions(e) {
    return Request.post(apiUrl("Layers/GetManualSymbologyOptions"), {
      UserGuid: e
    });
  },
  getNormalizedYieldOptions: function getNormalizedYieldOptions(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetNormalizedYieldOptions"), {
      Model: {
        FieldGuid: e
      },
      UserGuid: t
    });
  },
  getCoverageSurfaceMapImage: getCoverageSurfaceMapImage,
  getColorRamp: getColorRamp,
  getEventSurfaceStats: function getEventSurfaceStats(e, t) {
    return Request.post(apiUrl("Layers/GetEventSurfaceStats"), {
      Model: {
        FieldGuid: e,
        PolygonJson: t
      }
    });
  },
  getSeedStrongOptions: function getSeedStrongOptions(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetSeedStrongOptions"), {
      Model: {
        FieldGuid: e
      },
      UserGuid: t
    });
  },
  getSurfaceClassBreakInfo: function getSurfaceClassBreakInfo(e) {
    return Request.post(apiUrl("Layers/GetSurfaceClassBreakInfo"), {
      Model: e
    });
  },
  getSurfaceDGGInfo: function getSurfaceDGGInfo(e) {
    return Request.post(apiUrl("Layers/GetSurfaceDGGInfo"), {
      Model: e
    });
  },
  getSurfaceEventLayerPoints: getSurfaceEventLayerPoints,
  getSymbologyOptions: function getSymbologyOptions(e) {
    return Request.post(apiUrl("Layers/GetSymbologyOptions"), {
      UserGuid: e
    });
  },
  getUserAnalysisLayerTypeAccess: function getUserAnalysisLayerTypeAccess(e) {
    return Request.post(apiUrl("AnalysisLayers/GetLoggedInUserAnalysisLayerTypeAccess"), {
      UserGuid: e
    });
  },
  reprocessSoilTypes: function reprocessSoilTypes(e, t) {
    return Request.post(apiUrl("SetUpField/ReprocessSoilTypesForField"), {
      Model: e,
      UserGuid: t
    });
  },
  runNormalizedYield: function runNormalizedYield(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RunNormalizedYield"), {
      Model: e,
      UserGuid: t
    });
  },
  validNormalizedYield: function validNormalizedYield(e, t) {
    return Request.post(apiUrl("AnalysisLayers/ValidNormalizedYield"), {
      Model: e,
      UserGuid: t
    });
  },
  runSeedStrong: function runSeedStrong(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RunSeedStrong"), {
      Model: e,
      UserGuid: t
    });
  },
  validSeedStrong: function validSeedStrong(e, t) {
    return Request.post(apiUrl("AnalysisLayers/ValidSeedStrong"), {
      Model: e,
      UserGuid: t
    });
  },
  runProfitLoss: function runProfitLoss(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RunProfitLoss"), {
      Model: e,
      UserGuid: t
    });
  },
  validProfitLoss: function validProfitLoss(e, t) {
    return Request.post(apiUrl("AnalysisLayers/ValidProfitLoss"), {
      Model: e,
      UserGuid: t
    });
  },
  runEcData: function runEcData(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RunEcData"), {
      Model: e,
      UserGuid: t
    });
  },
  validEcData: function validEcData(e, t) {
    return Request.post(apiUrl("AnalysisLayers/ValidEcData"), {
      Model: e,
      UserGuid: t
    });
  },
  setSurfaceLayerProperties: function setSurfaceLayerProperties(e, _ref15) {
    var t = _ref15.agEventGeneralGuid,
        r = _ref15.agEventTransactionTypeGuid,
        i = _ref15.analysisLayerGuid,
        s = _ref15.classificationMethodGuid,
        a = _ref15.colorRampGuid,
        n = _ref15.colorSchemeGuid,
        o = _ref15.numberOfClasses,
        u = _ref15.nutrientGuid,
        l = _ref15.recGeneralGuid,
        d = _ref15.recName,
        p = _ref15.selectedAttributeGuid,
        c = _ref15.selectedSurfaceTypeGuid,
        m = _ref15.soilsFieldGuid,
        y = _ref15.surfaceGuid,
        g = _ref15.surfaceRendererGuid,
        G = _ref15.surfaceType,
        R = _ref15.surfaceTypeDisplayName;
    var E = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var S = apiUrl(E ? "Layers/GetChangeLayerPropertiesManual" : "Layers/GetChangeLayerProperties");
    return Request.post(S, {
      UserGuid: e,
      Model: {
        agEventGeneralGuid: t,
        agEventTransactionTypeGuid: r,
        analysisLayerGuid: i,
        classificationMethodGuid: s,
        colorRampGuid: a,
        colorSchemeGuid: n,
        numberOfClasses: o,
        nutrientGuid: u,
        recGeneralGuid: l,
        recName: d,
        selectedAttributeGuid: p,
        selectedSurfaceTypeGuid: c,
        soilsFieldGuid: m,
        surfaceGuid: y,
        surfaceRendererGuid: g,
        surfaceType: G,
        surfaceTypeDisplayName: R
      }
    });
  },
  updateImageryLayer: function updateImageryLayer(e, t) {
    return Request.post(apiUrl("Layers/UpdateImageryLayer"), {
      Model: e,
      UserGuid: t
    });
  },
  updateNormalizedYield: function updateNormalizedYield(e, t) {
    return Request.post(apiUrl("AnalysisLayers/UpdateNormalizedYield"), {
      Model: e,
      UserGuid: t
    });
  },
  updateSeedStrong: function updateSeedStrong(e, t) {
    return Request.post(apiUrl("AnalysisLayers/UpdateSeedStrong"), {
      Model: e,
      UserGuid: t
    });
  },
  updateProfitLoss: function updateProfitLoss(e, t) {
    return Request.post(apiUrl("AnalysisLayers/UpdateProfitLoss"), {
      Model: e,
      UserGuid: t
    });
  },
  updateEcData: function updateEcData(e, t) {
    return Request.post(apiUrl("AnalysisLayers/UpdateEcData"), {
      Model: e,
      UserGuid: t
    });
  },
  retrieveEcDataAttributes: function retrieveEcDataAttributes(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RetrieveEcDataAttributes"), {
      Model: e,
      UserGuid: t
    });
  },
  getActualDetailedCost: function getActualDetailedCost(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetActualDetailedCost"), {
      Model: e,
      UserGuid: t
    });
  },
  getManagementAreaTypes: function getManagementAreaTypes(e) {
    return Request.post(apiUrl("AnalysisLayers/GetManagementAreaTypes"), {
      UserGuid: e
    });
  },
  getManagementAreaAttributes: function getManagementAreaAttributes(e, t) {
    return Request.post(apiUrl("AnalysisLayers/GetManagementAreaAttributes"), {
      Model: e,
      UserGuid: t
    });
  },
  runManagementArea: function runManagementArea(e, t) {
    return Request.post(apiUrl("AnalysisLayers/RunManagementArea"), {
      Model: e,
      UserGuid: t
    });
  },
  validManagementArea: function validManagementArea(e, t) {
    return Request.post(apiUrl("AnalysisLayers/ValidManagementArea"), {
      Model: e,
      UserGuid: t
    });
  },
  updateManagementArea: function updateManagementArea(e, t) {
    return Request.post(apiUrl("AnalysisLayers/UpdateManagementArea"), {
      Model: e,
      UserGuid: t
    });
  }
}),
    wt = apiUrl("SetupLocationMigration/MigrationValidate"),
    Vt = apiUrl("SetupLocationMigration/Migrate"),
    xt = apiUrl("SetupLocationMigration/GetInvalidLocations"),
    Yt = Object.freeze({
  __proto__: null,
  POST_VALIDATE: wt,
  POST_MIGRATE: Vt,
  GET_INVALID_LOCATIONS: xt
}),
    jt = apiUrl("AgBytes/GetTargetValueAutoSearchList"),
    Ht = apiUrl("AgBytes/AddTargetValue"),
    zt = apiUrl("AgBytes/DeleteTargetValueList"),
    kt = apiUrl("AgBytes/ExportTargetValueList"),
    $t = apiUrl("AgBytes/GetTargetValue"),
    Qt = apiUrl("AgBytes/TargetValueImport"),
    Wt = apiUrl("AgBytes/ValidTargetValueImport"),
    Zt = apiUrl("AgBytes/GetNextTargetValueId"),
    Kt = apiUrl("AgBytes/GetTargetValueSelectAllList"),
    Jt = apiUrl("AgBytes/UpdateTargetValue"),
    Xt = apiUrl("AgBytes/GetTargetValueList"),
    er = Object.freeze({
  __proto__: null,
  AUTO_SEARCH_URL: jt,
  CREATE: Ht,
  DELETE: zt,
  EXPORT_FILE_NAME: "NutrientTargetValueExport",
  EXPORT_URL: kt,
  GETRECORD: $t,
  IMPORT_URL: Qt,
  IMPORT_VALID_URL: Wt,
  NEXT_ID: Zt,
  SELECT_ALL: Kt,
  UPDATE: Jt,
  URL: Xt,
  addNutrientTargetValue: function addNutrientTargetValue(e, t) {
    return Request.post(Ht, {
      UserGuid: e,
      Model: t
    });
  },
  deleteNutrientTargetValue: function deleteNutrientTargetValue(e, t) {
    return Request.delete(zt, {
      UserGuid: e,
      Model: t
    });
  },
  deleteSelectedNutrientTargetValue: function deleteSelectedNutrientTargetValue(e, t) {
    return Request.delete(kt, {
      UserGuid: e,
      Model: t
    });
  },
  exportNutrientTargetValueList: function exportNutrientTargetValueList(e, t) {
    return Request.post(kt, {
      UserGuid: e,
      Model: t
    });
  },
  getNextNutrientTargetValueId: function getNextNutrientTargetValueId(e) {
    return Request.post(Zt, {
      UserGuid: e
    });
  },
  getNutrientTargetValue: function getNutrientTargetValue(e, t) {
    return Request.post($t, {
      UserGuid: e,
      Model: t
    });
  },
  getNutrientTargetValueSelectAllList: function getNutrientTargetValueSelectAllList(e, t) {
    return Request.post(Kt, {
      UserGuid: e,
      Model: t
    });
  },
  nutrientTargetValueImport: function nutrientTargetValueImport(e, t) {
    return Request.post(Qt, {
      UserGuid: e,
      Model: t
    });
  },
  searchNutrientTargetValueList: function searchNutrientTargetValueList(e, t) {
    return Request.post(jt, {
      UserGuid: e,
      Model: t
    });
  },
  updateNutrientTargetValue: function updateNutrientTargetValue(e, t) {
    return Request.post(Jt, {
      UserGuid: e,
      Model: t
    });
  },
  validNutrientTargetValueImport: function validNutrientTargetValueImport(e, t) {
    return Request.post(Wt, {
      UserGuid: e,
      Model: t
    });
  }
}),
    tr = apiUrl("SetupCompany/PostCompany"),
    rr = apiUrl("SystemSetting/GetOwnerAutoSearchList"),
    ir = apiUrl("SetupCompany/PostCompany"),
    sr = apiUrl("SystemSetting/GetOwnerList"),
    ar = apiUrl("SetupCompany/GetCompany"),
    nr = apiUrl("SetupCompany/GetThemeListAsList"),
    or = apiUrl("SetupCompany/UpdateCompany"),
    ur = apiUrl("SetupCompany/GetOwnerPersonalityList"),
    lr = apiUrl("SetupCompany/GetOwnerAdminUserList"),
    dr = Object.freeze({
  __proto__: null,
  ADD_OWNER: tr,
  AUTO_SEARCH_URL: rr,
  CREATE: ir,
  GET_OWNER_LIST: sr,
  GET_RECORD: ar,
  GET_THEME_LIST: nr,
  UPDATE: or,
  GET_OWNER_PERSONALITY_LIST: ur,
  GET_OWNER_ADMIN_USER_LIST: lr,
  addOwner: function addOwner(e) {
    return Request.post(tr, e);
  }
}),
    pr = apiUrl("Person/AddPerson"),
    cr = apiUrl("Person/GetAutoSearchList"),
    mr = apiUrl("Person/DeletePerson"),
    yr = apiUrl("Person/ExportPersonList"),
    gr = apiUrl("Person/GetAutoCreateReportsList"),
    Gr = apiUrl("Person/GetPerson"),
    Rr = apiUrl("Person/GetPersons"),
    Er = apiUrl("Person/GetUserRoles"),
    Sr = apiUrl("Person/PersonImport"),
    Tr = apiUrl("Person/ValidPersonImport"),
    Ar = apiUrl("Person/SearchPersonAffiliations"),
    _r = apiUrl("Person/ResetUserPassword"),
    Lr = apiUrl("Person/SearchPersonWithoutUser"),
    fr = apiUrl("Person/SearchPersonWithUser"),
    Ur = apiUrl("Person/GetPersonSelectAllList"),
    Pr = apiUrl("Person/UpdatePerson"),
    Ir = Object.freeze({
  __proto__: null,
  ADD_PERSON: pr,
  AUTO_SEARCH_PERSON: cr,
  DELETE_PERSON: mr,
  EXPORT_PERSON_LIST: yr,
  GET_AUTO_CREATE_REPORTS_LIST: gr,
  GET_PERSON: Gr,
  GET_PERSONS: Rr,
  GET_USER_ROLES: Er,
  IMPORT_PERSON_LIST: Sr,
  IMPORT_PERSON_VALID_URL: Tr,
  PERSON_AFFILIATION: Ar,
  RESET_PASSWORD: _r,
  SEARCH_PERSON_WITHOUT_USER: Lr,
  SEARCH_PERSON_WITH_USER: fr,
  SELECT_ALL_PERSON: Ur,
  UPDATE_PERSON: Pr,
  addPerson: function addPerson(e, t) {
    return Request.post(apiUrl("Person/AddPerson"), {
      UserGuid: e,
      Model: t
    });
  },
  addPersonUser: function addPersonUser(e, t) {
    return Request.post(apiUrl("Person/AddPersonUser"), {
      UserGuid: e,
      Model: t
    });
  },
  deletePerson: function deletePerson(e, t) {
    return Request.delete(mr, {
      UserGuid: e,
      Model: t
    });
  },
  exportPersonList: function exportPersonList(e, t) {
    return Request.post(yr, {
      UserGuid: e,
      Model: t
    });
  },
  getAutoCreateReportsList: function getAutoCreateReportsList(e, t) {
    return Request.post(gr, {
      UserGuid: e,
      Model: t
    });
  },
  getCustomerAffiliationsBySalesIds: function getCustomerAffiliationsBySalesIds(e, t) {
    return Request.post(apiUrl("Person/GetCustomerAffiliationsBySalesIds"), {
      UserGuid: e,
      Model: t
    });
  },
  getOrgLevelSelection: function getOrgLevelSelection(e, t) {
    return Request.post(apiUrl("SetupOrgLevel/GetOrgLevelSelection"), {
      UserGuid: e,
      Model: t
    });
  },
  getPerson: function getPerson(e, t) {
    return Request.post(Gr, {
      UserGuid: e,
      Model: t
    });
  },
  getPersonInfo: function getPersonInfo(e, t) {
    return Request.post(apiUrl("Person/GetPersonInfo/"), {
      UserGuid: e,
      Model: t
    });
  },
  getSetupUserAccess: function getSetupUserAccess(e) {
    return Request.post(apiUrl("Person/GetSetupUserAccess"), {
      UserGuid: e
    });
  },
  getSupervisorName: function getSupervisorName(e, t) {
    return Request.post(apiUrl("Person/GetSupervisorName"), {
      UserGuid: e,
      Model: t
    });
  },
  getTimezones: function getTimezones(e) {
    return Request.post(apiUrl("User/GetTimeZoneList"), {
      UserGuid: e
    });
  },
  personImport: function personImport(e, t) {
    return Request.post(Sr, {
      UserGuid: e,
      Model: t
    });
  },
  replaceAffiliations: function replaceAffiliations(e, t) {
    return Request.post(apiUrl("Person/ReplacePersonAffiliations"), {
      UserGuid: e,
      Model: t
    });
  },
  resetUserPassword: function resetUserPassword(e, t) {
    return Request.post(_r, {
      UserGuid: e,
      Model: t
    });
  },
  searchPersonAffiliations: function searchPersonAffiliations(e, t) {
    return Request.post(apiUrl("Person/SearchPersonAffiliations"), {
      UserGuid: e,
      Model: t
    });
  },
  searchPersonWithoutUser: function searchPersonWithoutUser(e, t) {
    return Request.post(Lr, {
      UserGuid: e,
      Model: t
    });
  },
  searchPersonWithUser: function searchPersonWithUser(e, t) {
    return Request.post(fr, {
      UserGuid: e,
      Model: t
    });
  },
  updatePerson: function updatePerson(e, t) {
    return Request.post(apiUrl("Person/UpdatePerson"), {
      UserGuid: e,
      Model: t
    });
  },
  validPersonImport: function validPersonImport(e, t) {
    return Request.post(Tr, {
      UserGuid: e,
      Model: t
    });
  }
}),
    vr = apiUrl("UserPreference/GetUserPreferences"),
    hr = apiUrl("UserPreference/SaveUserPreferences"),
    Or = Object.freeze({
  __proto__: null,
  GET_USER_PREFERENCES: vr,
  SAVE_USER_PREFERENCES: hr,
  saveUserPreferences: function saveUserPreferences(e) {
    return Request.post(hr, e);
  },
  getUserPreferences: function getUserPreferences(e) {
    return Request.post(vr, e);
  }
}),
    Fr = apiUrl("ProductAssignment/AddProductAssignment"),
    Cr = apiUrl("ProductAssignment/GetAutoSearchList"),
    Mr = apiUrl("ProductAssignment/DeleteProductAssignmentList"),
    Dr = apiUrl("ProductAssignment/ExportProductAssignmentList"),
    Nr = apiUrl("ProductAssignment/GetProductAssignment"),
    qr = apiUrl("ProductAssignment/GetProductAssignmentList"),
    br = apiUrl("ProductAssignment/GetUserRoles"),
    Br = apiUrl("ProductAssignment/ProductAssignmentImport"),
    wr = apiUrl("ProductAssignment/ValidProductAssignmentImport"),
    Vr = apiUrl("AgBytes/GetNutrientDropDownList"),
    xr = apiUrl("AgBytes/GetProductAgBytesList"),
    Yr = apiUrl("ProductAssignment/GetProductAssignmentSelectAllList"),
    jr = apiUrl("ProductAssignment/UpdateProductAssignment"),
    Hr = apiUrl("ProductAssignment/GetSystemAttributeList"),
    zr = Object.freeze({
  __proto__: null,
  ADD_PRODUCT_ASSIGNMENT: Fr,
  AUTO_SEARCH_PRODUCT_ASSIGNMENT: Cr,
  DELETE_PRODUCT_ASSIGNMENT: Mr,
  EXPORT_PRODUCT_ASSIGNMENT_LIST: Dr,
  GET_PRODUCT_ASSIGNMENT: Nr,
  GET_PRODUCT_ASSIGNMENTS: qr,
  GET_USER_ROLES: br,
  IMPORT_PRODUCT_ASSIGNMENT_LIST: Br,
  IMPORT_PRODUCT_ASSIGNMENT_VALID_URL: wr,
  REQUEST_NUTRIENT: Vr,
  REQUEST_PRODUCT: xr,
  SELECT_ALL_PRODUCT_ASSIGNMENT: Yr,
  UPDATE_PRODUCT_ASSIGNMENT: jr,
  GET_SYSTEM_ATTRIBUTES: Hr
}),
    kr = aggregateUrlGenerator("report", "v1.0"),
    $r = apiUrl("AgBytes/GetCropDropdownList"),
    Qr = apiUrl("Reports/GetSummaryReportTypeList"),
    Wr = apiUrl("Reports/GetFieldReportTypeList"),
    Zr = apiUrl("Reports/GetReportTypeList"),
    Kr = apiUrl("Reports/GetReportTypePageList"),
    Jr = apiUrl("Reports/CreateReport"),
    Xr = apiUrl("Reports/GetReportList"),
    ei = apiUrl("Reports/GetAutoCompleteData"),
    ti = apiUrl("Reports/GetSelectAllList"),
    ri = apiUrl("Reports/getYieldByCategoryList"),
    ii = apiUrl("Reports/updateYieldByCategory"),
    si = apiUrl("Reports/GetFieldReportList"),
    ai = apiUrl("Reports/GetFieldAutoCompleteData"),
    ni = apiUrl("Reports/GetFieldSelectAllList"),
    oi = apiUrl("Reports/GetSummaryReportList"),
    ui = apiUrl("Reports/GetSummaryReportAutoCompleteData"),
    li = apiUrl("Reports/GetSummarySelectAllList"),
    di = apiUrl("Reports/DeleteReportNamesList"),
    pi = apiUrl("Reports/EmailReportLinkList"),
    ci = apiUrl("Reports/BatchDownloadFileList"),
    mi = apiUrl("Reports/PrintReportList"),
    yi = apiUrl("Reports/MergeReportList");

var gi, Gi, Ri;
!function (e) {
  e.ACCUPOINT = "Accupoint", e.ACCUPOINT_DEFINED_LEGEND_EBU = "AccupointDefinedLegendEBU", e.ACCUPOINT_DEFINED_LEGEND_MULTIFIELD = "AccupointDefinedLegendMultiField", e.ACCUPOINT_DEFINED_LEGEND_MULTIFIELD_PRODUCT_REC = "AccupointDefinedLegendMultiFieldProductRec", e.ACCUPOINT_SUMMARY = "AccupointSummary", e.AGOPTICS_REPORT = "GlAgOptics", e.AGR_INTELLIGENCE_PROFIT_LOSS = "AGRIntelligenceProfitLoss", e.AGVANCE_SKY_APPLICATION_REPORT = "AgvanceSkyApplication", e.AGVANCE_SKY_BOUNDARY_MAP_REPORT = "AgvanceSkyBoundary", e.AGVANCE_SKY_COVER_PAGE = "AgvanceSkyCoverPage", e.AGVANCE_SKY_CROP_PLANNING_REPORT = "AgvanceSkyCropPlanning", e.AGVANCE_SKY_FIELD_RECORD_NOTEBOOK = "AgvanceSkyFieldRecordNotebook", e.AGVANCE_SKY_FIELD_REFERENCE_LIST = "AgvanceSkyFieldReferenceList", e.AGVANCE_SKY_GROWER_SUMMARY_APPLICATION_REPORT = "AgvanceSkyGrowerSummaryApplication", e.AGVANCE_SKY_HARVEST_SUMMARY = "AgvanceSkyHarvestSummary", e.AGVANCE_SKY_NUTRIENT_ATLAS = "AgvanceSkyNutrient", e.AGVANCE_SKY_PLANTING_REPORT = "AgvanceSkyPlanting", e.AGVANCE_SKY_PLANTING_SUMMARY = "AgvanceSkyPlantingSummary", e.AGVANCE_SKY_REC_REPORT = "AgvanceSkyRecs", e.AGVANCE_SKY_RECS_REPORT_APPLICATION = "AgvanceSkyRecsApplication", e.AGVANCE_SKY_RECS_REPORT_PLANTING = "AgvanceSkyRecsPlanting", e.AGVANCE_SKY_SCOUTING_DETAIL_REPORT = "AgvanceSkyScouting", e.AGVANCE_SKY_SCOUTING_REPORT = "AgvanceSkyScoutingSummary", e.AGVANCE_SKY_SOIL_TEST_RESULTS_REPORT = "AgvanceSkySoilTestResults", e.AGVANCE_SKY_SOILS_REPORT = "AgvanceSkySoils", e.AGVANCE_SKY_YIELD_REPORT = "AgvanceSkyYield", e.APPLICATION_MAP = "ApplicationMap", e.AQUALENZ = "AquaLenz", e.ASK_REPORT = "Ask", e.BOUNDARY_MAP_REPORT = "FarmMap", e.COREMAX = "GlCoreMax", e.COREMAX_DEFINED_LEGEND_MULTIFIELD = "CoreMaxDefinedLegendMultiField", e.COREMAX_DEFINED_LEGEND_MULTIFIELD_PRODUCT_REC = "CoreMaxDefinedLegendMultiFieldProductRec", e.COREMAX_RESULTS_ONLY = "CoreMaxResultsOnly", e.COREMAX_SUMMARY = "CoreMaxSummary", e.CROP_MAP_REPORT = "CropMap", e.EXTRACTOR_REPORT = "Extractor", e.EXTRACTOR_SUMMARY_REPORT = "ExtractorSummary", e.FOUR_MATION_RX_REPORT = "4MationRx", e.FOUR_MATION_ZONES_REPORT = "4MationZones", e.GROLINK_PROFIT_LOSS = "GroLinkProfitLoss", e.HARVEST_SUMMARY = "HarvestSummary", e.HARVEST_SUMMARY_MULTI_SEASON = "HarvestSummaryMultiSeason", e.HYGROUND = "HyGround", e.HYGROUND_DEFINED_LEGEND = "HyGroundDefinedLegend", e.HYGROUND_DEFINED_LEGEND_EBU = "HyGroundDefinedLegendEBU", e.HYGROUND_DESERT = "HyGroundDesert", e.HYGROUND_WESTERN = "HyGroundWestern", e.HYGROUND_NORTHWEST = "HyGroundNorthwest", e.HYGROUND_FSR = "HyGroundFsr", e.HYGROUND_RESULTS_ONLY = "HyGroundResultsOnly", e.HYGROUND_DEFINED_LEGEND_MULTIFIELD = "HyGroundDefinedLegendMultiField", e.HYGROUND_DEFINED_LEGEND_MULTIFIELD_PRODUCT_REC = "HyGroundDefinedLegendMultiFieldProductRec", e.HYGROUND_SUMMARY = "HyGroundSummary", e.INSPEX_REPORT = "Inspex", e.LAB_SUBMISSION_FORM_REPORT = "LabSubmissionForm", e.LOADSHEET = "Loadsheet", e.NUTRIENT_MAP = "NutrientMap", e.PLANTING_MANUAL_LOADSHEET = "PlantingManualLoadsheet", e.PLANTING_SUMMARY = "PlantingSummary", e.PREVEAL_REPORT = "Preveal", e.PRINT_LAYER_REPORT = "Print Layer", e.PRINT_SPLIT_LAYER_REPORT = "PrintSplitLayer", e.PRODUCT_REC_SUMMARY_REPORT = "ProductRecSummary", e.PROFIT_OR_LOSS_MAP_REPORT = "ProfitOrLoss", e.RECS_REPORT_APPLICATION = "RecsReportApplication", e.RECS_REPORT_PLANTING = "RecsReportPlanting", e.REPORT_BOUNDARY_MAP = "ReportBoundaryMap", e.REPORT_IMAGE_ONLY = "ReportImage", e.SAMPLE_BAG_LABELS_REPORT = "SampleBagLabels", e.SEED_STRONG_REPORT = "SeedStrong", e.SEED_STRONG_DH_REPORT = "SeedStrongDH", e.SEED_STRONG_RX_REPORT = "SeedStrongRx", e.SLICE_REPORT = "Slice", e.SLICE_SUMMARY_REPORT = "SliceSummary", e.SOIL_SAMPLE_RESULTS_REPORT = "SoilSampleResults", e.SOIL_TESTING_REQUIRED_REPORT = "SoilTestingRequired", e.SOIL_TYPE_REPORT = "SoilTypeMap", e.TRUE_REC_REPORT = "GlTrueRec", e.TRU_YIELD_IMPACT_REPORT = "TruYieldImpact", e.TRU_YIELD_SUMMARY_REPORT = "TruYieldSummary", e.WEATHER_REPORT = "WeatherHistory", e.YIELD_BY_ANALYSIS_REPORT = "YieldByAnalysis", e.YIELD_BY_REPORT = "YieldBy", e.YIELD_MAP_REPORT = "YieldMap", e.YIELD_ONE_IMPACT_REPORT = "GlYieldOneImpact", e.YIELD_ONE_SUMMARY_REPORT = "GlYieldOneSummary";
}(gi || (gi = {})), function (e) {
  e.AGVANCE_SKY_FIELD_REFERENCE_LIST = "field-reference-list", e.AGVANCE_SKY_HARVEST_SUMMARY = "sky-harvest-summary", e.AGVANCE_SKY_PLANTING_SUMMARY = "sky-planting-summary", e.AQUALENZ = "aqualenz";
}(Gi || (Gi = {})), function (e) {
  e[e.Web = 0] = "Web", e[e.Mobile = 1] = "Mobile", e[e.CLU = 2] = "CLU";
}(Ri || (Ri = {}));
var Ei = Object.freeze({
  __proto__: null,
  GET_CROP_DROPDOWN_URL: $r,
  GET_SUMMARY_REPORT_TYPE_LIST_URL: Qr,
  GET_FIELD_REPORT_TYPE_LIST_URL: Wr,
  GET_REPORT_TYPE_LIST_URL: Zr,
  GET_REPORT_TYPE_PAGE_LIST_URL: Kr,
  CREATE_REPORT_URL: Jr,
  GET_REPORT_LIST_URL: Xr,
  GET_REPORT_AUTO_SEARCH_URL: ei,
  GET_REPORT_SELECT_ALL_URL: ti,
  GET_YIELD_BY_COMPARE_BY_OPTIONS_LIST_URL: ri,
  UPDATE_YIELD_BY_COMPARE_BY_OPTIONS_LIST_URL: ii,
  GET_FIELD_REPORT_LIST_URL: si,
  GET_FIELD_REPORT_AUTOSEARCH_URL: ai,
  GET_FIELD_SELECT_ALL_URL: ni,
  GET_SUMMARY_REPORT_LIST_URL: oi,
  GET_SUMMARY_REPORT_AUTOSEARCH_URL: ui,
  GET_SUMMARY_SELECT_ALL_URL: li,
  DELETE_REPORT_NAMES_LIST_URL: di,
  EMAIL_REPORT_LINK_LIST_URL: pi,
  BATCH_DOWNLOAD_FILE_LIST: ci,
  PRINT_REPORT_LIST: mi,

  get ReportNames() {
    return gi;
  },

  get ReportEndpoints() {
    return Gi;
  },

  createChromelessReport: function createChromelessReport(e, t, r) {
    return Request.post(apiUrl("Reports/CreateChromelessReport"), {
      UserGuid: e,
      ReportName: t,
      ReportParams: r
    });
  },
  mergeReportList: function mergeReportList(e) {
    return Request.post(yi, e);
  },
  getFields: function getFields(e) {
    return Request.post(kr("field"), e);
  },
  createReport: function createReport(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

    var s = _objectSpread(_objectSpread({}, t), {}, {
      clientId: i ? Ri[Ri.Mobile] : Ri[Ri.Web]
    }),
        a = {
      "user-guid": e
    };

    switch (r) {
      case gi.AGVANCE_SKY_FIELD_REFERENCE_LIST:
        return Request.post(kr("".concat(Gi.AGVANCE_SKY_FIELD_REFERENCE_LIST)), s, "application/json", a);

      case gi.AGVANCE_SKY_HARVEST_SUMMARY:
        return Request.post(kr("".concat(Gi.AGVANCE_SKY_HARVEST_SUMMARY)), s, "application/json", a);

      case gi.AGVANCE_SKY_PLANTING_SUMMARY:
        return Request.post(kr("".concat(Gi.AGVANCE_SKY_PLANTING_SUMMARY)), s, "application/json", a);

      case gi.AQUALENZ:
        return Request.post(kr("".concat(Gi.AQUALENZ)), s, "application/json", a);

      default:
        throw new Error("Invalid report type");
    }
  }
}),
    Si = aggregateUrlGenerator("search", "v1.0");
var Ti, Ai;
!function (e) {
  e.UserHierarchyAccess = "userHierarchyAccess", e.UserHierarchyAccessUnfiltered = "userHierarchyAccessUnfiltered";
}(Ti || (Ti = {})), function (e) {
  e.Match = "match", e.Remove = "remove";
}(Ai || (Ai = {}));

var _i = Object.freeze({
  __proto__: null,
  maxPageSize: 2147483647,
  Props: {
    CUSTOMER_CITY: "city",
    CUSTOMER_GUID: "customerGuid",
    CUSTOMER_NAME: "customerName",
    CUSTOMER_STREET: "street",
    STATE_ABBR: "stateAbbr"
  },

  get UserAccess() {
    return Ti;
  },

  get LastUsedCustomer() {
    return Ai;
  },

  getCustomers: function () {
    var _getCustomers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return Request.post(Si("customer"), e, "application/json", {}, !0, t);

            case 2:
              return _context9.abrupt("return", _context9.sent.map(function (e) {
                return {
                  customerGuid: e.customerId,
                  customerName: e.name,
                  city: e.city,
                  state: e.state,
                  street: e.street,
                  stateAbbr: e.state,
                  zipCode: e.zipCode
                };
              }));

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function getCustomers(_x19, _x20) {
      return _getCustomers.apply(this, arguments);
    }

    return getCustomers;
  }(),
  getFilters: function getFilters(e, t) {
    return Request.post(Si("filter"), e, "application/json", {}, !0, t);
  },
  getCustomerFields: function getCustomerFields(e, t) {
    return Request.post(Si("customerField"), e, "application/json", {}, !0, t);
  },
  selectCustomerFields: function selectCustomerFields(e, t) {
    return Request.post(Si("customerField/select"), e, "application/json", {}, !0, t);
  },
  getSummary: function getSummary(e, t) {
    return Request.post(Si("summary"), e, "application/json", {}, !0, t);
  },
  getFields: function getFields(e, t) {
    return Request.post(Si("field"), e, "application/json", {}, !0, t);
  },
  getFieldIds: function getFieldIds(e, t) {
    return Request.post(Si("field/id"), e, "application/json", {}, !0, t);
  }
}),
    Li = apiUrl("AgBytes/GetProductAgBytesListByProductType"),
    fi = Object.freeze({
  __proto__: null,
  GET_PRODUCT_AG_BYTES_LIST_BY_PRODUCT_TYPE: Li,
  buildHaasAgiisFiles: function buildHaasAgiisFiles(e, t) {
    var r = new window.FormData();

    for (var i = 0; i < e.length; i++) {
      var _t6 = e[i];
      r.append("file" + i.toString(), _t6);
    }

    return r.append("loggedInUserGuid", t), Request.post(apiUrl("AgBytes/BuildHaasAgiisFiles"), r, "multipart/form-data");
  },
  getUnitAgBytesList: function getUnitAgBytesList(e, t, r) {
    return Request.post(apiUrl("AgBytes/GetUnitAgBytesList"), {
      UserGuid: e,
      Model: {
        sortField: t,
        unitType: r
      }
    });
  },
  getEquationParameterPickList: function getEquationParameterPickList(e) {
    return Request.post(apiUrl("AgBytes/GetEquationParameterPickList"), {
      UserGuid: e
    });
  }
}),
    Ui = apiUrl("SurfaceDefaults/AddSurfaceDefaults"),
    Pi = apiUrl("SurfaceDefaults/GetAutoSearchList"),
    Ii = apiUrl("SurfaceDefaults/DeleteSurfaceDefaultsList"),
    vi = apiUrl("SurfaceDefaults/ExportSurfaceDefaultsList"),
    hi = apiUrl("SurfaceDefaults/GetCompanyList"),
    Oi = apiUrl("SurfaceDefaults/GetSurfaceDefaults"),
    Fi = apiUrl("SurfaceDefaults/GetSurfaceDefaultsList"),
    Ci = apiUrl("SurfaceDefaults/GetUserRoles"),
    Mi = apiUrl("SurfaceDefaults/SurfaceDefaultsImport"),
    Di = apiUrl("SurfaceDefaults/ValidSurfaceDefaultsImport"),
    Ni = apiUrl("SurfaceDefaults/GetClassificationMethodList"),
    qi = apiUrl("SurfaceDefaults/GetFilteredLocationList"),
    bi = apiUrl("SurfaceDefaults/GetDisplayTypeList"),
    Bi = apiUrl("SurfaceDefaults/GetSystemAttributeList"),
    wi = apiUrl("SurfaceDefaults/GetSurfaceDefaultsSelectAllList"),
    Vi = apiUrl("SurfaceDefaults/UpdateSurfaceDefaults"),
    xi = Object.freeze({
  __proto__: null,
  ADD_SURFACE_DEFAULTS: Ui,
  AUTO_SEARCH_SURFACE_DEFAULTS: Pi,
  DELETE_SURFACE_DEFAULTS: Ii,
  EXPORT_SURFACE_DEFAULTS_LIST: vi,
  GET_COMPANY_LIST: hi,
  GET_SURFACE_DEFAULTS: Oi,
  GET_SURFACE_DEFAULTS_LIST: Fi,
  GET_USER_ROLES: Ci,
  IMPORT_SURFACE_DEFAULTS_LIST: Mi,
  IMPORT_SURFACE_DEFAULTS_VALID_URL: Di,
  REQUEST_CLASSIFICATION_METHOD_LIST: Ni,
  REQUEST_FILTERED_LOCATION_LIST: qi,
  REQUEST_DISPLAY_TYPE_LIST: bi,
  REQUEST_SYSTEM_ATTRIBUTE_LIST: Bi,
  SELECT_ALL_SURFACE_DEFAULTS: wi,
  UPDATE_SURFACE_DEFAULTS: Vi,
  getSymbologyOptions: function getSymbologyOptions(e) {
    return Request.post(apiUrl("Layers/GetSymbologyOptions"), {
      UserGuid: e
    });
  }
}),
    Yi = apiUrl("SystemSetting/GetSystemFaviconUrl"),
    ji = apiUrl("SystemSetting/GetSystemSettings"),
    Hi = apiUrl("SystemSetting/UpdateSystemSettings"),
    zi = apiUrl("SystemSetting/GetMobileAppDetails"),
    ki = apiUrl("SystemSetting/GetReleaseNotes"),
    $i = apiUrl("SystemSetting/UpdateReleaseNotes"),
    Qi = Object.freeze({
  __proto__: null,
  GET_SYSTEM_FAVICON: Yi,
  GET_SYSTEM_SETTINGS: ji,
  UPDATE_SYSTEM_SETTINGS: Hi,
  GET_MOBILE_APP_DETAILS: zi,
  GET_RELEASE_NOTES: ki,
  UPDATE_RELEASE_NOTES: $i,
  getSystemFaviconUrl: function getSystemFaviconUrl(_ref16) {
    var e = _ref16.UserGuid,
        t = _ref16.Model;
    return Request.post(Yi, {
      UserGuid: e,
      Model: t
    });
  },
  getMobileAppDetails: function getMobileAppDetails(_ref17) {
    var e = _ref17.UserGuid;
    return Request.post(zi, {
      UserGuid: e
    });
  },
  getSystemSettings: function getSystemSettings(e) {
    return Request.post(ji, e);
  },
  logError: function logError(e, t, r) {
    return Request.post(apiUrl("Logs/Log"), {
      data: [{
        clientType: navigator.userAgent,
        company: t || "",
        logger: "[anonymous]",
        level: "ERROR",
        message: r,
        timestamp: Date.now(),
        url: window.location.href,
        user: e,
        version: window.process_env.__BUILD_STR__ || "unset"
      }]
    });
  },
  updateSystemSettings: function updateSystemSettings(e) {
    return Request.post(Hi, e);
  },
  getReleaseNotes: function getReleaseNotes() {
    return Request.post(ki);
  },
  UpdateReleaseNotes: function UpdateReleaseNotes(e) {
    return Request.post($i, e);
  }
}),
    Wi = apiUrl("Template/GetAutoCompleteData"),
    Zi = apiUrl("Template/AddImportTemplate"),
    Ki = apiUrl("Template/DeleteTemplateList"),
    Ji = apiUrl("Template/GetExistingTemplateGridData"),
    Xi = apiUrl("Template/GetExistingTemplateGridDataByTemplateGuid"),
    es = apiUrl("Template/GetImportControllerTemplate"),
    ts = apiUrl("Template/GetImportTemplate"),
    rs = apiUrl("Template/GetNewTemplateGridDataForm"),
    is = apiUrl("Template/GetSampleAttributeList"),
    ss = apiUrl("Template/UpdateImportTemplate"),
    as = apiUrl("Template/GetAllEditableTemplateList"),
    ns = apiUrl("Template/VerifyTemplateFile"),
    os = apiUrl("Template/GetImportSampleTemplates"),
    us = apiUrl("Template/GetImportTypeList"),
    ls = apiUrl("Template/GetVendorList"),
    ds = Object.freeze({
  __proto__: null,
  AUTO_SEARCH_URL: Wi,
  CREATE: Zi,
  DELETE: Ki,
  GET_EXISTING_TEMPLATE_GRID_DATA_URL: Ji,
  GET_EXISTING_TEMPLATE_GRID_DATA_BY_TEMPLATE_GUID_URL: Xi,
  GET_IMPORT_CONTROLLER_TEMPLATE_URL: es,
  GET_IMPORT_TEMPLATE_URL: ts,
  GET_NEW_TEMPLATE_URL: rs,
  GET_SAMPLE_ATTRIBUTES_URL: is,
  MODEL_NAME: "templateManager",
  UPDATE: ss,
  URL: as,
  VERIFY_TEMPLATE_URL: ns,
  REQUEST_GET_IMPORT_SAMPLE_TEMPLATES: os,
  REQUEST_GET_IMPORT_TYPE_LIST: us,
  VENDOR_DATA_URL: ls,
  getImportTemplate: function getImportTemplate(e, t) {
    return Request.post(ts, {
      UserGuid: e,
      Model: t
    });
  }
}),
    ps = apiUrl("SetupUserRole/AddUserRole"),
    cs = apiUrl("SetupUserRole/GetAutoSearchList"),
    ms = apiUrl("SetupUserRole/DeleteUserRole"),
    ys = apiUrl("SetupUserRole/GetRoleList"),
    gs = apiUrl("SetupUserRole/GetUserRole"),
    Gs = apiUrl("SetupUserRole/GetRoleUserList"),
    Rs = apiUrl("SetupUserRole/UpdateUserRole"),
    Es = Object.freeze({
  __proto__: null,
  ADD_USER_ROLE: ps,
  AUTO_SEARCH_URL: cs,
  DELETE_USER_ROLE: ms,
  GET_ROLE_LIST: ys,
  GET_USER_ROLE: gs,
  GET_USER_ROLE_LIST: Gs,
  UPDATE_USER_ROLE: Rs,
  addUserRole: function addUserRole(e) {
    return Request.post(ps, e);
  }
}),
    Ss = apiUrl("Vendor/GetVendorList"),
    Ts = apiUrl("Vendor/GetVendor"),
    As = apiUrl("Vendor/AddVendor"),
    _s = apiUrl("Vendor/UpdateVendor"),
    Ls = apiUrl("Vendor/DeleteVendor"),
    fs = apiUrl("Vendor/GetAutoSearchList"),
    Us = Object.freeze({
  __proto__: null,
  GET_VENDOR_LIST: Ss,
  GETRECORD: Ts,
  CREATE: As,
  UPDATE: _s,
  DELETE: Ls,
  AUTO_SEARCH_URL: fs,
  searchVendor: function searchVendor(e, t) {
    return Request.post(apiUrl("Vendor/GetVendorSearch"), {
      UserGuid: e,
      Model: t
    });
  },
  getTestingLabVendorList: function getTestingLabVendorList(e) {
    return Request.post(apiUrl("Vendor/GetTestingLabVendorList"), {
      UserGuid: e
    });
  },
  getTestPackageList: function getTestPackageList(e, t) {
    return Request.post(apiUrl("Vendor/GetTestPackageList"), {
      UserGuid: e,
      Model: t
    });
  }
});

var Ps, Is, vs, hs;
!function (e) {
  e.cropHeatUnit = "cropHeatUnit", e.evapotranspiration = "evapotranspiration", e.growingDegreeDay = "growingDegreeDay", e.precipitationAmount = "precipitationAmount", e.solarRadiation = "solarRadiation", e.avgWindSpeedList = "avgWindSpeedList", e.cropHeatUnitList = "cropHeatUnitList", e.evapotranspirationList = "evapotranspirationList", e.growingDegreeDayList = "growingDegreeDayList", e.maxRelativeHumidityList = "maxRelativeHumidityList", e.maxTemperatureList = "maxTemperatureList", e.minRelativeHumidityList = "minRelativeHumidityList", e.minTemperatureList = "minTemperatureList", e.precipitationAmountList = "precipitationAmountList", e.solarRadiationList = "solarRadiationList";
}(Ps || (Ps = {})), function (e) {
  e.cloudCoverList = "cloudCoverList", e.dewPointList = "dewPointList", e.feelsLikeList = "feelsLikeList", e.heatIndexList = "heatIndexList", e.minutesOfSunshineList = "minutesOfSunshineList", e.peakWindSpeedList = "peakWindSpeedList", e.precipitationAmountList = "precipitationAmountList", e.precipitationTypeList = "precipitationTypeList", e.relativeHumidityList = "relativeHumidityList", e.seaLevelPressureList = "seaLevelPressureList", e.solarRadiationList = "solarRadiationList", e.temperatureList = "temperatureList", e.visibilityList = "visibilityList", e.weatherCodeList = "weatherCodeList", e.weatherDescriptionList = "weatherDescriptionList", e.wetBulbTemperatureList = "wetBulbTemperatureList", e.windChillList = "windChillList", e.windDirectionList = "windDirectionList", e.windGustList = "windGustList", e.windSpeedList = "windSpeedList";
}(Is || (Is = {})), function (e) {
  e.base = "wx:base", e.type = "wx:type", e.uom = "wx:uom", e.value = "wx:value", e.values = "wx:values";
}(vs || (vs = {})), function (e) {
  e.start = "wx:startDate", e.end = "wx:endDate";
}(hs || (hs = {}));

var Os = Object.freeze({
  __proto__: null,

  get DIOParam() {
    return Ps;
  },

  get HIOParam() {
    return Is;
  },

  DTNWeatherSentry: /*#__PURE__*/function () {
    function DTNWeatherSentry(e) {
      _classCallCheck(this, DTNWeatherSentry);

      this.credentials = ":", this.obsfcstUrl = "https://weather.dtn.com/basic/rest-3.4/obsfcst.wsgi", this.credentials = e;
    }

    _createClass(DTNWeatherSentry, [{
      key: "getDailyInterpolatedObservations",
      value: function getDailyInterpolatedObservations(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return this._breakUpAndMergeRequests("DailyInterpolatedObservation", "0001", e, t, r, 59);
      }
    }, {
      key: "getDailyInterpolatedObservationLists",
      value: function getDailyInterpolatedObservationLists(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return this._breakUpAndMergeRequests("DailyInterpolatedObservation", "0002", e, t, r, 59);
      }
    }, {
      key: "getHourlyInterpolatedObservations",
      value: function getHourlyInterpolatedObservations(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return this._breakUpAndMergeRequests("HourlyInterpolatedObservation", "0001", e, t, r, 6);
      }
    }, {
      key: "parseDIO",
      value: function parseDIO(e, t) {
        var _this4 = this;

        var r = e.getElementsByTagName("wx:".concat(t));

        switch (t) {
          case Ps.cropHeatUnit:
          case Ps.growingDegreeDay:
            return r.map(function (t, r) {
              return {
                base: _this4._parseValue(t, vs.base),
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                value: _this4._parseValue(t, vs.value)
              };
            });

          case Ps.precipitationAmount:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                type: _this4._parseValue(t, vs.type),
                uom: _this4._parseValue(t, vs.uom),
                value: _this4._parseValue(t, vs.value)
              };
            });

          case Ps.evapotranspiration:
          case Ps.solarRadiation:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                uom: _this4._parseValue(t, vs.uom),
                value: _this4._parseValue(t, vs.value)
              };
            });

          case Ps.precipitationAmountList:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                type: _this4._parseValue(t, vs.type),
                uom: _this4._parseValue(t, vs.uom),
                values: _this4._parseValue(t, vs.values).split(" ")
              };
            });

          case Ps.avgWindSpeedList:
          case Ps.evapotranspirationList:
          case Ps.maxTemperatureList:
          case Ps.minTemperatureList:
          case Ps.solarRadiationList:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                uom: _this4._parseValue(t, vs.uom),
                values: _this4._parseValue(t, vs.values).split(" ")
              };
            });

          case Ps.cropHeatUnitList:
          case Ps.growingDegreeDayList:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                base: _this4._parseValue(t, vs.base),
                values: _this4._parseValue(t, vs.values).split(" ")
              };
            });

          case Ps.maxRelativeHumidityList:
          case Ps.minRelativeHumidityList:
            return r.map(function (t, r) {
              return {
                endDate: _this4._parseDate(e, hs.end, r),
                startDate: _this4._parseDate(e, hs.start, r),
                values: t.value.split(" ")
              };
            });

          default:
            return [];
        }
      }
    }, {
      key: "parseError",
      value: function parseError(e) {
        if (null == e || "faultCondition" !== e.name) return null;
        var t = e.children.find(function (e) {
          return "severity" === e.name;
        }),
            r = e.children.find(function (e) {
          return "code" === e.name;
        }),
            i = e.children.find(function (e) {
          return "detail" === e.name;
        });
        return null == t || null == r || null == i ? null : {
          severity: t.value,
          code: r.value,
          detail: i.value
        };
      }
    }, {
      key: "parseHIO",
      value: function parseHIO(e, t) {
        var _this5 = this;

        var r = e.getElementsByTagName("wx:".concat(t));

        switch (t) {
          case Is.dewPointList:
          case Is.feelsLikeList:
          case Is.heatIndexList:
          case Is.minutesOfSunshineList:
          case Is.peakWindSpeedList:
          case Is.precipitationAmountList:
          case Is.seaLevelPressureList:
          case Is.solarRadiationList:
          case Is.temperatureList:
          case Is.visibilityList:
          case Is.wetBulbTemperatureList:
          case Is.windChillList:
          case Is.windDirectionList:
          case Is.windGustList:
          case Is.windSpeedList:
            return r.map(function (t, r) {
              return {
                endDate: _this5._parseDate(e, hs.end, r),
                startDate: _this5._parseDate(e, hs.start, r),
                uom: _this5._parseValue(t, vs.uom),
                values: _this5._parseValue(t, vs.values).split(" ")
              };
            });

          case Is.cloudCoverList:
          case Is.precipitationTypeList:
          case Is.relativeHumidityList:
          case Is.weatherDescriptionList:
          case Is.weatherCodeList:
            return r.map(function (t, r) {
              return {
                endDate: _this5._parseDate(e, hs.end, r),
                startDate: _this5._parseDate(e, hs.start, r),
                values: t.value.split(" ")
              };
            });

          default:
            return [];
        }
      }
    }, {
      key: "_baseHeaders",
      value: function _baseHeaders() {
        return {
          headers: {
            Authorization: "Basic ".concat(btoa("".concat(this.credentials)))
          }
        };
      }
    }, {
      key: "_baseParams",
      value: function _baseParams(e, t, r, i) {
        var s = r.latitude,
            a = r.longitude;
        return {
          dataType: e,
          dataTypeMode: t,
          startDate: i.startDate.toISOString(),
          endDate: i.endDate.toISOString(),
          latitude: s,
          longitude: a
        };
      }
    }, {
      key: "_breakUpAndMergeRequests",
      value: function _breakUpAndMergeRequests(e, t, r, s) {
        var _this6 = this;

        var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var n = arguments.length > 5 ? arguments[5] : undefined;
        var o = i(s.startDate),
            u = i(s.endDate),
            l = 24 * n;
        return u.diff(o, "hours") < l ? this._fetchData(e, t, r, s, a) : new Promise(function (s, n) {
          var d = [];

          for (; o.isBefore(u); o.add(l, "hours")) {
            d.push(_this6._fetchData(e, t, r, {
              startDate: o.toDate(),
              endDate: u.diff(i(o).add(l, "hours")) > l ? i(o).add(l, "hours").toDate() : u.toDate()
            }, a));
          }

          Promise.all(d).then(function (e) {
            var t = e.find(function (e) {
              return "faultCondition" === e.name;
            });
            if (null != t) throw t;
            s(e.reduce(function (e, t) {
              return null == e ? t : (e.children[0].children.push(t.children[0].children[0]), e);
            }, null));
          }).catch(function (e) {
            n(e);
          });
        });
      }
    }, {
      key: "_fetchData",
      value: function _fetchData(e, t, r, i) {
        var _this7 = this;

        var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        return new Promise(function (n, o) {
          var u = _this7._baseParams(e, t, r, i);

          var _iterator3 = _createForOfIteratorHelper(a),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _e4 = _step3.value;
              u[_e4] = 1;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var l = new URL(_this7.obsfcstUrl);
          Object.keys(u).forEach(function (e) {
            return l.searchParams.append(e, u[e]);
          }), fetch(l.href, _this7._baseHeaders()).then(function (e) {
            return e.text().then(function (e) {
              return n(new s().parseFromString(e));
            });
          }).catch(function (e) {
            return o(e);
          });
        });
      }
    }, {
      key: "_parseDate",
      value: function _parseDate(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return i(e.getElementsByTagName(t)[r].value).toDate();
      }
    }, {
      key: "_parseValue",
      value: function _parseValue(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return e.getElementsByTagName(t)[r].value;
      }
    }]);

    return DTNWeatherSentry;
  }()
}),
    Fs = apiUrl("SetupZapper/GetAttributeList"),
    Cs = apiUrl("SetupZapper/GetAttributeTree"),
    Ms = apiUrl("SetupZapper/GetLocationTreeChildren"),
    Ds = apiUrl("SetupZapper/GetOrgLevelAutoCompleteList"),
    Ns = apiUrl("SetupZapper/GetUserCompanyList"),
    qs = apiUrl("SetupZapper/SaveAssignments"),
    bs = apiUrl("SetupZapper/SaveAssignmentsAttribute"),
    Bs = Object.freeze({
  __proto__: null,
  FETCH_ATTRIBUTES_URL: Fs,
  FETCH_ATTRIBUTES_TREE_URL: Cs,
  FETCH_LOCATION_HIERARCHY_ENTITIES_URL: Ms,
  FETCH_LOCATION_HIERARCHY_URL: Ds,
  GET_USER_COMPANY_LIST: Ns,
  SAVE_ASSIGNMENT_URL: qs,
  SAVE_ASSIGNMENTS_ENTITIES_TAB_URL: bs
}),
    transformZoneGeometries = function transformZoneGeometries(e) {
  var t = e.zonePolygons;
  return e.zonePolygons = t.map(function (e) {
    return L.geometryFromApiInplace(e, "shape", L.getSpatialReference(102100));
  }), e;
},
    zoneToGraphic = function zoneToGraphic(e) {
  var t = new a({
    rings: e.zonePolygons.map(function (e) {
      return e.shape.rings;
    }).flat(),
    spatialReference: L.getSpatialReference(102100)
  }),
      r = _objectSpread(_objectSpread({}, e), {}, {
    shape: t
  });

  return L.toFeature(r, "shape", !0, ["zonePolygons"]);
},
    ws = Object.freeze({
  __proto__: null,
  transformZoneGeometries: transformZoneGeometries,
  zoneToGraphic: zoneToGraphic
}),
    Vs = aggregateUrlGenerator("analysislayer", "v1.0"),
    xs = {
  applyAnalysisToArea: "ApplyAnalysisToArea",
  analysisLayerAreaId: "AnalysisLayerAreaId",
  analysisLayerAreaGuid: "AnalysisLayerAreaGuid",
  analysisLayerGuid: "AnalysisLayerGuid",
  calculatedArea: "CalculatedArea"
};

var ZoneEndpoint$2 = /*#__PURE__*/function () {
  function ZoneEndpoint$2() {
    _classCallCheck(this, ZoneEndpoint$2);
  }

  _createClass(ZoneEndpoint$2, null, [{
    key: "fetch",
    value: function fetch(e) {
      return fetchByList({
        endpoint: ZoneEndpoint$2.descriptor,
        filterName: "analysisLayer",
        limit: 100
      }, ZoneEndpoint$2.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return ZoneEndpoint$2;
}();

ZoneEndpoint$2.descriptor = {
  name: "zone",
  aggregateUrl: Vs,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformZoneGeometries);
  }
};

var Ys = ZoneEndpoint$2.fetch,
    js = Object.freeze({
  __proto__: null,
  zoneEsriFields: [{
    name: "AnalysisLayerGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "AnalysisLayerTypeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "AnalysisLayerType",
    type: "esriFieldTypeString"
  }, {
    name: "NAME",
    type: "esriFieldTypeString"
  }, {
    name: "FieldBoundaryGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "FieldGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "NumClasses",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "AnalysisLayerAreaId",
    type: "esriFieldTypeInteger"
  }, {
    name: "AnalysisLayerAreaGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "ApplyAnalysisToArea",
    type: "esriFieldTypeInteger"
  }, {
    name: "EventAreaPolygonGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SHAPE",
    type: "esriFieldTypeGeometry"
  }, {
    name: "DefinedLegendGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SurfaceTypeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "DefinedLegendName",
    type: "esriFieldTypeString"
  }, {
    name: "LayerFileGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "ClassificationMethodGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "ESRI_OID",
    type: "esriFieldTypeOID"
  }],
  mappedZoneFields: xs,
  fetchAnalysisZones: Ys,
  getAnalysisLayerSummary: function getAnalysisLayerSummary(e, t) {
    var r = {
      "user-guid": t
    };
    return Request.post(Vs("/summary", null), e, "application/json", r);
  },
  runImagerySetup: function runImagerySetup(e, t) {
    return e.userGuid = t, Request.put(Vs("imagery-setup/".concat(e.analysisLayerGuid)), e);
  },
  deleteImagerySetupLayer: function deleteImagerySetupLayer(e, t) {
    return Request.delete(Vs("imagery-setup/".concat(e)), null);
  },
  deleteSurface: function deleteSurface(e, t) {
    return Request.delete(Vs("surface/".concat(e)), null);
  }
}),
    Hs = aggregateUrlGenerator("event", "v1.0"),
    transformShape = function transformShape(e) {
  return L.geometryFromApiInplace(e, "shape", L.getSpatialReference(102100));
},
    zs = {
  eventAreaGuid: "EventAreaGuid",
  agEventGeneralGuid: "AgEventGeneralGuid",
  eventAreaID: "EventAreaId",
  applyEventToArea: "ApplyEventToArea",
  calculatedArea: "CalculatedArea"
};

var ZoneEndpoint$1 = /*#__PURE__*/function () {
  function ZoneEndpoint$1() {
    _classCallCheck(this, ZoneEndpoint$1);
  }

  _createClass(ZoneEndpoint$1, null, [{
    key: "fetchForEventGenerals",
    value: function fetchForEventGenerals(e) {
      return fetchByList({
        endpoint: ZoneEndpoint$1.descriptor,
        filterName: "eventGeneral",
        limit: 100
      }, ZoneEndpoint$1.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "fetchForEventAreas",
    value: function fetchForEventAreas(e) {
      return fetchByList({
        endpoint: ZoneEndpoint$1.descriptor,
        filterName: "eventArea",
        limit: 100
      }, ZoneEndpoint$1.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return ZoneEndpoint$1;
}();

ZoneEndpoint$1.descriptor = {
  name: "zone",
  aggregateUrl: Hs,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformZoneGeometries);
  }
};

var fetchZones = function fetchZones(e, t) {
  var r = e.filter(function (e) {
    return e;
  }),
      i = t.filter(function (e) {
    return e;
  });
  return 0 === r.length && 0 === i.length ? Promise.resolve([]) : 0 !== r.length ? ZoneEndpoint$1.fetchForEventGenerals(r) : ZoneEndpoint$1.fetchForEventAreas(i);
},
    ks = {
  surfaceGuid: "SurfaceGuid",
  sampleID: "SampleId",
  sequenceID: "SequenceId",
  depthID: "DepthId",
  value: "Value",
  shape: "Shape",
  matched: "Matched"
};

var $s;
!function (e) {
  e.TISSUE = "eventSampleTissuePointGuid", e.SOIL = "soilSamplePointGuid";
}($s || ($s = {}));
var Qs = {
  surfaceGuid: {
    name: "surfaceGuid",
    alias: "surfaceGuid",
    type: "guid"
  },
  sampleID: {
    name: "sampleId",
    alias: "sampleId",
    type: "integer"
  },
  sequenceID: {
    name: "sequenceId",
    alias: "sequenceId",
    type: "integer"
  },
  depthID: {
    name: "depthId",
    alias: "depthId",
    type: "integer"
  },
  value: {
    name: "value",
    alias: "value",
    type: "double"
  },
  matched: {
    name: "matched",
    alias: "matched",
    type: "integer"
  }
};

var SampleSiteEndpoint = /*#__PURE__*/function () {
  function SampleSiteEndpoint() {
    _classCallCheck(this, SampleSiteEndpoint);
  }

  _createClass(SampleSiteEndpoint, null, [{
    key: "fetch",
    value: function fetch(e, t) {
      var r = t.filter(function (e) {
        return e;
      }).map(function (e) {
        return e.toString();
      });
      return fetchByList({
        endpoint: SampleSiteEndpoint.descriptor,
        filterName: "surface",
        limit: 100
      }, SampleSiteEndpoint.baseQueryString(r), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString(e) {
      var t = new QueryString();
      return t.append("spatialReference", "wgs84"), t.append("depthId", e), t;
    }
  }]);

  return SampleSiteEndpoint;
}();

SampleSiteEndpoint.descriptor = {
  name: "sampleSite",
  aggregateUrl: Hs,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformShape);
  }
};

var Ws = SampleSiteEndpoint.fetch,
    sampleSiteToGraphic = function sampleSiteToGraphic(e) {
  return L.toFeature(e, "shape", !0);
};

var SampleSiteSequenceEndpoint = /*#__PURE__*/function () {
  function SampleSiteSequenceEndpoint() {
    _classCallCheck(this, SampleSiteSequenceEndpoint);
  }

  _createClass(SampleSiteSequenceEndpoint, null, [{
    key: "fetch",
    value: function fetch(e) {
      return fetchByList({
        endpoint: SampleSiteSequenceEndpoint.descriptor,
        filterName: "eventGeneral",
        limit: 100
      }, SampleSiteSequenceEndpoint.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return SampleSiteSequenceEndpoint;
}();

SampleSiteSequenceEndpoint.descriptor = {
  name: "sampleSite/sequence",
  aggregateUrl: Hs,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformShape);
  }
};

var Zs = SampleSiteSequenceEndpoint.fetch,
    sampleSiteSequenceToGraphic = function sampleSiteSequenceToGraphic(e) {
  return L.toFeature(e, "shape", !0);
};

var ResurfaceEventEndpoint = /*#__PURE__*/function () {
  function ResurfaceEventEndpoint() {
    _classCallCheck(this, ResurfaceEventEndpoint);
  }

  _createClass(ResurfaceEventEndpoint, null, [{
    key: "fetch",
    value: function fetch(e) {
      var t = new QueryString();
      return t.set("field", e), function (e, t) {
        var r = new BasicRequestTask(),
            i = new BasicResponseTask();
        return fetchBy(r, i, e, t).then(function (e) {
          return e[0];
        });
      }({
        endpoint: ResurfaceEventEndpoint.descriptor
      }, t);
    }
  }]);

  return ResurfaceEventEndpoint;
}();

ResurfaceEventEndpoint.descriptor = {
  name: "resurfaceEvent",
  aggregateUrl: Hs,
  extractFromResponse: function extractFromResponse(e) {
    return _toConsumableArray(e.results);
  }
};
var Ks = ResurfaceEventEndpoint.fetch,
    Js = Object.freeze({
  __proto__: null,
  zoneEsriFields: [{
    name: "EventAreaGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "EventAreaPolygonGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "AgEventGeneralGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "EventAreaId",
    type: "esriFieldTypeInteger"
  }, {
    name: "ApplyEventToArea",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "FieldBoundaryGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "CalculatedArea",
    type: "esriFieldTypeDouble"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }, {
    name: "ObjectId",
    type: "esriFieldTypeInteger"
  }],
  mappedZoneFields: zs,
  fetchZones: fetchZones,
  sampleSiteEsriFields: [{
    name: "SurfaceGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SampleId",
    type: "esriFieldTypeInteger"
  }, {
    name: "SequenceId",
    type: "esriFieldTypeInteger"
  }, {
    name: "DepthId",
    type: "esriFieldTypeInteger"
  }, {
    name: "Value",
    type: "esriFieldTypeDouble"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedSampleSiteFields: ks,

  get samplePointGuidProperty() {
    return $s;
  },

  mappedSampleSiteDefinitions: Qs,
  fetchSampleSites: Ws,
  sampleSiteToGraphic: sampleSiteToGraphic,
  sampleSiteSequenceEsriFields: [{
    name: "AgEventGeneralGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "SampleId",
    type: "esriFieldTypeInteger"
  }, {
    name: "SequenceId",
    type: "esriFieldTypeInteger"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }, {
    name: "productivityRating",
    type: "esriFieldTypeString"
  }, {
    name: "pointGuid",
    type: "esriFieldTypeGUID"
  }],
  mappedSampleSiteSequenceFields: {
    agEventGeneralGuid: "AgEventGeneralGuid",
    sampleID: "SampleId",
    sequenceID: "SequenceId",
    depthID: "DepthId",
    productivityRating: "ProductivityRating",
    pointGuid: "PointGuid"
  },
  fetchSampleSiteSequences: Zs,
  sampleSiteSequenceToGraphic: sampleSiteSequenceToGraphic,
  fetchResurfaceEventList: Ks,
  mergeEventFromRec: function mergeEventFromRec(e, t) {
    var r = Hs("".concat(e, "/rec/").concat(t));
    return Request.put(r);
  },
  samplingDepthOptions: function samplingDepthOptions(e) {
    var t = Hs("sampling/depth/option");
    return Request.post(t, e);
  }
}),
    Xs = aggregateUrlGenerator("rec", "v1.0"),
    ea = {
  applyRecToArea: "ApplyRecToArea",
  calculatedArea: "CalculatedArea",
  recAreaID: "RecAreaId",
  recAreaGuid: "RecAreaGuid",
  recGeneralGuid: "RecGeneralGuid"
};

var ZoneEndpoint = /*#__PURE__*/function () {
  function ZoneEndpoint() {
    _classCallCheck(this, ZoneEndpoint);
  }

  _createClass(ZoneEndpoint, null, [{
    key: "fetch",
    value: function fetch(e) {
      return fetchByList({
        endpoint: ZoneEndpoint.descriptor,
        filterName: "recGeneral",
        limit: 100
      }, ZoneEndpoint.baseQueryString(), e.filter(function (e) {
        return e;
      }));
    }
  }, {
    key: "baseQueryString",
    value: function baseQueryString() {
      var e = new QueryString();
      return e.append("spatialReference", "wgs84"), e;
    }
  }]);

  return ZoneEndpoint;
}();

ZoneEndpoint.descriptor = {
  name: "zone",
  aggregateUrl: Xs,
  extractFromResponse: function extractFromResponse(e) {
    return e.results.map(transformZoneGeometries);
  }
};
var ta = ZoneEndpoint.fetch,
    ra = Object.freeze({
  __proto__: null,
  zoneEsriFields: [{
    name: "RecGeneralGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "FieldGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "Name",
    type: "esriFieldTypeString"
  }, {
    name: "AlternativeName",
    type: "esriFieldTypeString"
  }, {
    name: "RecAreaGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecAreaId",
    type: "esriFieldTypeString"
  }, {
    name: "ApplyRecToArea",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "EventAreaPolygonGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "CalculatedArea",
    type: "esriFieldTypeDouble"
  }, {
    name: "FieldBoundaryGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecTypeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecType",
    type: "esriFieldTypeString"
  }, {
    name: "CroppingSeasonGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "CroppingSeasonCycleGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "GeneralCropGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "GeneralCropPurposeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "GeneralCropPlantingDate",
    type: "esriFieldTypeDate"
  }, {
    name: "GeneralVarietyHybridGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "Notes",
    type: "esriFieldTypeString"
  }, {
    name: "PlanName",
    type: "esriFieldTypeString"
  }, {
    name: "CreatedDate",
    type: "esriFieldTypeDate"
  }, {
    name: "RecGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecCropGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecCropPurposeGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "EquationGroupGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "YieldGoal",
    type: "esriFieldTypeDouble"
  }, {
    name: "YieldGoalUnitGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecVarietyHybridGuid",
    type: "esriFieldTypeGUID"
  }, {
    name: "RecCropPlantingDate",
    type: "esriFieldTypeDate"
  }, {
    name: "AdjustAllPercent",
    type: "esriFieldTypeSingle"
  }, {
    name: "ReleasedYN",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "RecGeneralActiveYN",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "RecActiveYN",
    type: "esriFieldTypeSmallInteger"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedZoneFields: ea,
  fetchRecAreaZones: ta
});
var ia = "http://json-schema.org/draft-04/schema#",
    sa = {
  IAgEvent: {
    properties: {
      agEventGuid: {
        type: ["null", "string"]
      },
      agEventModel: {},
      agEventTransactionTypeGuid: {
        type: "string"
      },
      eventAreaGuid: {
        type: ["null", "string"]
      }
    },
    required: ["agEventGuid", "agEventModel", "eventAreaGuid"],
    type: "object"
  },
  IZone: {
    properties: {
      generalGuid: {
        type: "string"
      },
      details: {
        items: {
          $ref: "#/definitions/IAgEvent"
        },
        type: "array"
      },
      applyToArea: {
        type: "boolean"
      },
      classBreak: {
        anyOf: [{
          $ref: "#/definitions/IAgEventClassBreak"
        }, {
          type: "null"
        }]
      },
      zoneGuid: {
        type: "string"
      },
      id: {
        type: "number"
      },
      fieldBoundaryGuid: {
        type: ["null", "string"]
      },
      calculatedArea: {
        type: ["null", "number"]
      },
      polygons: {
        items: {
          $ref: "#/definitions/IZonePolygon"
        },
        type: "array"
      }
    },
    required: ["generalGuid", "details", "applyToArea", "classBreak", "zoneGuid", "id", "calculatedArea", "polygons"],
    type: "object"
  },
  IZonePolygon: {
    properties: {
      polygonGuid: {
        type: ["null", "string"]
      },
      shape: {
        type: ["null", "string"]
      }
    },
    required: ["polygonGuid", "shape"],
    type: "object"
  },
  IAgEventClassBreak: {
    properties: {
      acreage: {
        type: ["null", "number"]
      },
      blue: {
        type: ["null", "number"]
      },
      classId: {
        type: ["null", "number"]
      },
      zoneGuid: {
        type: "string"
      },
      green: {
        type: ["null", "number"]
      },
      heading: {
        type: "string"
      },
      label: {
        type: "string"
      },
      lowerBound: {
        type: ["null", "string"]
      },
      red: {
        type: ["null", "number"]
      },
      upperBound: {
        type: ["null", "string"]
      }
    },
    required: ["acreage", "blue", "classId", "zoneGuid", "green", "heading", "label", "lowerBound", "red", "upperBound"],
    type: "object"
  },
  IAgEventType: {
    properties: {
      agEventTransactionTypeGuid: {
        type: ["null", "string"]
      },
      sampleType: {
        type: ["null", "string"]
      },
      sampleTypeGuid: {
        type: ["null", "string"]
      },
      typeName: {
        type: ["null", "string"]
      }
    },
    type: "object"
  }
},
    aa = {
  agEventGeneralGuid: {
    type: "string"
  },
  agEventTypeList: {
    items: {
      $ref: "#/definitions/IAgEventType"
    },
    type: "array"
  },
  densityRatingGuid: {
    type: ["null", "string"]
  },
  soilConditionGuid: {
    type: ["null", "string"]
  },
  soilTemperature: {
    type: ["null", "number"]
  },
  airTemperature: {
    type: ["null", "number"]
  },
  cloudCoverPercentage: {
    type: ["null", "number"]
  },
  directionGuid: {
    type: ["null", "string"]
  },
  generalWeatherGuid: {
    type: ["null", "string"]
  },
  humidityPercentage: {
    type: ["null", "number"]
  },
  precipitation: {
    type: ["null", "number"]
  },
  windSpeed: {
    type: ["null", "number"]
  },
  creationType: {
    type: "string"
  },
  creationTypeGuid: {
    type: ["null", "string"]
  },
  cropGrowingDays: {
    type: ["null", "number"]
  },
  croppingSeasonCycleGuid: {
    type: ["null", "string"]
  },
  croppingSeasonGuid: {
    type: ["null", "string"]
  },
  endDate: {
    type: "string"
  },
  endTime: {
    type: "string"
  },
  zones: {
    items: {
      $ref: "#/definitions/IZone"
    },
    type: "array"
  },
  eventName: {
    type: "string"
  },
  fieldBoundaryGuid: {
    type: "string"
  },
  fieldGuid: {
    type: "string"
  },
  customerGuid: {
    type: "string"
  },
  isClassified: {
    type: "boolean"
  },
  notes: {
    type: ["null", "string"]
  },
  personList: {
    items: {},
    type: "array"
  },
  startDate: {
    type: "string"
  },
  startTime: {
    type: "string"
  }
},
    na = ["agEventGeneralGuid", "agEventTypeList", "creationType", "creationTypeGuid", "croppingSeasonGuid", "endDate", "endTime", "eventAreaList", "eventName", "fieldBoundaryGuid", "fieldGuid", "isClassified", "personList", "startDate", "startTime"];
var oa = {
  $schema: ia,
  definitions: sa,
  properties: aa,
  required: na,
  type: "object"
},
    ua = Object.freeze({
  __proto__: null,
  $schema: ia,
  definitions: sa,
  properties: aa,
  required: na,
  type: "object",
  default: oa
});
var la = "http://json-schema.org/draft-04/schema#",
    da = {
  properties: {
    activeYn: {
      type: "boolean"
    },
    agEventDisplayName: {
      type: "string"
    },
    agEventGeneralGuid: {
      type: "string"
    },
    agEventGuid: {
      type: "string"
    },
    agEventName: {
      type: "string"
    },
    agEventTransactionTypeGuid: {
      type: "string"
    },
    agEventTypeName: {
      type: "string"
    },
    cropDisplayName: {
      type: ["null", "string"]
    },
    cropGuids: {
      type: "array"
    },
    croppingSeasonGuid: {
      type: "string"
    },
    croppingSeasonName: {
      type: "string"
    },
    eventDate: {
      type: "string"
    },
    eventId: {
      type: "string"
    },
    fieldGuid: {
      type: "string"
    },
    hasSoilSampleResults: {
      type: "boolean"
    },
    importPoints: {
      properties: {
        importedPoints: {
          type: "number"
        },
        totalPoints: {
          type: "number"
        }
      },
      required: ["importedPoints", "totalPoints"],
      type: "object"
    },
    importedStatus: {
      type: "number"
    },
    modifiedDate: {
      type: "string"
    },
    modifiedBy: {
      type: "string"
    },
    numberOfSampleDepths: {
      type: ["null", "string"]
    },
    status: {
      type: ["null", "string"]
    }
  },
  required: ["activeYn", "agEventDisplayName", "agEventGeneralGuid", "agEventGuid", "agEventName", "agEventTypeName", "cropDisplayName", "cropGuids", "croppingSeasonGuid", "croppingSeasonName", "eventDate", "eventId", "fieldGuid", "hasSoilSampleResults", "importPoints", "importedStatus", "modifiedDate", "modifiedBy", "numberOfSampleDepths"],
  type: "object"
};
var pa = {
  $schema: la,
  items: da,
  type: "array"
},
    ca = Object.freeze({
  __proto__: null,
  $schema: la,
  items: da,
  type: "array",
  default: pa
}),
    ma = aggregateUrlGenerator("event", "v1.0");
var ya;
D.addSchema(ua, "eventdetails"), D.addSchema(ca, "eventsummary"), function (e) {
  e.DEFAULT = "default", e.COMPOSITE = "composite";
}(ya || (ya = {}));

var getFilterPointDataFromS3 = function getFilterPointDataFromS3(e) {
  var t = e;
  return Request.post(apiUrl("AgEvent/GetFilterPointDataFromS3"), {
    Model: t
  });
},
    ga = Object.freeze({
  __proto__: null,
  IEventDetailsSchemaKey: "eventdetails",
  EventSummarySchemaKey: "eventsummary",

  get labelMethods() {
    return ya;
  },

  activateEvent: function activateEvent(e, t) {
    return Request.post(apiUrl("AgEvent/ActivateEvent"), {
      UserGuid: e,
      Model: t
    });
  },
  addAgEvents: function addAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/AddAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  calibrateYield: function calibrateYield(e, t) {
    return Request.post(apiUrl("AgEvent/CalibrateYield"), {
      UserGuid: e,
      Model: t
    });
  },
  deactivateEvents: function deactivateEvents(e, t) {
    return Request.post(apiUrl("AgEvent/DeactivateEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  getAgEventListByAgEventGeneralGuid: function getAgEventListByAgEventGeneralGuid(e, t) {
    return Request.post(apiUrl("AgEvent/GetAgEventListByAgEventGeneralGuid"), {
      UserGuid: e,
      Model: t
    });
  },
  getAgEvents: function getAgEvents(e, t) {
    return validateResults(Request.get(ma(t)), D.getSchema("eventdetails")).then(function (e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        eventAreaList: e.eventAreaList.map(function (e) {
          return {
            eventAreaGuid: e.zoneGuid,
            eventAreaId: e.id,
            eventGeneralGuid: e.generalGuid,
            applyEventToArea: e.applyToArea,
            calculatedArea: e.calculatedArea,
            fieldBoundaryGuid: e.fieldBoundaryGuid,
            eventAreaClassBreak: e.classBreak,
            agEventList: e.details,
            zonePolygons: e.polygons.map(function (e) {
              return _objectSpread(_objectSpread({}, e), {}, {
                shape: null
              });
            })
          };
        })
      });
    });
  },
  getAgEventTypeList: function getAgEventTypeList(e) {
    return Request.post(apiUrl("AgEvent/GetAgEventTypeList"), {
      UserGuid: e
    });
  },
  getBatchAgEvents: function getBatchAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/GetBatchAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  getDefaultUserGridSettings: function getDefaultUserGridSettings(e) {
    return Request.get(apiUrl("SamplingEvent/GetDefaultUserGridSettings?loggedInUserGuid=".concat(e)));
  },
  getFilterPointDataFromS3: getFilterPointDataFromS3,
  getFilterSummary: function getFilterSummary(e) {
    var t = e;
    return Request.post(apiUrl("AgEvent/GetFilterSummaryData"), {
      Model: t
    });
  },
  getMergeAgEvents: function getMergeAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/GetMergeAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  getMergeSoilSampleResults: function getMergeSoilSampleResults(e, t) {
    return Request.post(apiUrl("SamplingImport/GetMergeSoilSampleResults"), {
      UserGuid: e,
      Model: t
    });
  },
  getHarvestEventLayerStats: function getHarvestEventLayerStats(e, _ref18) {
    var t = _ref18.agEventGeneralGuid,
        r = _ref18.agEventTransactionTypeGuid,
        i = _ref18.surfaceTypeDisplayName;
    return Request.post(apiUrl("AgEvent/GetHarvestEventLayerStats"), {
      UserGuid: e,
      Model: {
        agEventGeneralGuid: t,
        agEventTransactionTypeGuid: r,
        surfaceTypeDisplayName: i
      }
    });
  },
  getHarvestLoadList: function getHarvestLoadList(e, t) {
    return Request.post(apiUrl("AgEvent/GetHarvestLoadList"), {
      UserGuid: e,
      Model: t
    });
  },
  getObservationTypeList: function getObservationTypeList(e) {
    return Request.post(apiUrl("AgBytes/GetObservationTypeList"), {
      UserGuid: e
    });
  },
  getObservationPickList: function getObservationPickList(e) {
    return Request.post(apiUrl("AgBytes/GetObservationPickList"), {
      UserGuid: e
    });
  },
  getPastZones: function getPastZones(e) {
    var t = new QueryString();
    return t.append("FieldBoundaryGuid", e), Request.get(ma("pastZone", t.toString()));
  },
  getSamplePointsDepthConfig: function getSamplePointsDepthConfig(e, t) {
    return Request.post(apiUrl("SamplingEvent/GetSamplePointsDepthConfig"), {
      UserGuid: e,
      Model: t
    });
  },
  getScoutingTemplate: function getScoutingTemplate(e, t, r) {
    return Request.post(apiUrl("AgEvent/GetScoutingTemplate"), {
      UserGuid: e,
      Model: {
        cropGuid: t,
        cropPurposeGuid: r
      }
    });
  },
  getTissueCropGrowthStageList: function getTissueCropGrowthStageList(e, t) {
    return Request.post(apiUrl("SamplingEvent/GetTissueCropGrowthStageList"), {
      UserGuid: e,
      Model: t
    });
  },
  getUserDepthConfig: function getUserDepthConfig(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return Request.post(apiUrl("SamplingEvent/GetUserDepthConfig"), {
      UserGuid: e,
      Model: t
    });
  },
  getYieldCalibrationTypePicklist: function getYieldCalibrationTypePicklist(e) {
    return Request.post(apiUrl("AgEvent/GetYieldCalibrationTypePicklist"), {
      UserGuid: e
    });
  },
  setUserDepthConfig: function setUserDepthConfig(e, t) {
    return Request.post(apiUrl("SamplingEvent/SetUserDepthConfig"), {
      UserGuid: e,
      Model: t
    });
  },
  setScoutingTemplate: function setScoutingTemplate(e, t) {
    return Request.post(apiUrl("AgEvent/SetScoutingTemplate"), {
      UserGuid: e,
      Model: t
    });
  },
  mergeAgEvents: function mergeAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/MergeAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  mergeApplicationAgEvents: function mergeApplicationAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/MergeApplicationAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  updateAgEvents: function updateAgEvents(e, t) {
    return Request.post(apiUrl("AgEvent/UpdateAgEvents"), {
      UserGuid: e,
      Model: t
    });
  },
  validEventGeneral: function validEventGeneral(e, t) {
    return Request.post(apiUrl("AgEvent/ValidEventGeneral"), {
      UserGuid: e,
      Model: t
    });
  },
  copyScoutingPhotos: function copyScoutingPhotos(e, t) {
    return Request.post(apiUrl("AgEvent/CopyScoutingPhotos"), {
      UserGuid: e,
      Model: t
    });
  },
  deleteScoutingPhotos: function deleteScoutingPhotos(e) {
    return Request.post(apiUrl("AgEvent/DeleteScoutingPhotos"), {
      Model: e
    });
  },
  generateScoutingPhotoS3PreSignedUrls: function generateScoutingPhotoS3PreSignedUrls(e) {
    return Request.post(apiUrl("AgEvent/GenerateScoutingPhotoS3PreSignedUrls"), {
      Model: e
    });
  },
  getScoutingCropGrowthStageList: function getScoutingCropGrowthStageList(e, t) {
    return Request.post(apiUrl("AgBytes/GetScoutingGrowthStageOrderAgBytesList"), {
      UserGuid: e,
      Model: t
    });
  },
  getScoutingGrowthStageObservationList: function getScoutingGrowthStageObservationList(e, t) {
    return Request.post(apiUrl("AgBytes/GetScoutingGrowthStageObservationAgBytesList"), {
      UserGuid: e,
      Model: t
    });
  },
  fetchSummaries: function () {
    var _fetchSummaries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
      var t, r;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              t = {
                field: e
              };
              _context10.next = 3;
              return Request.post(ma("summary"), t, "application/json");

            case 3:
              r = _context10.sent;
              _context10.next = 6;
              return validateResults(Promise.resolve(r), D.getSchema("eventsummary"));

            case 6:
              return _context10.abrupt("return", _context10.sent);

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function fetchSummaries(_x21) {
      return _fetchSummaries.apply(this, arguments);
    }

    return fetchSummaries;
  }(),
  getNextEventId: function getNextEventId(e) {
    return Request.get(apiUrl("SamplingEvent/GetNextEventId?loggedInUserGuid=".concat(e)));
  },
  mergeWaterSampling: function mergeWaterSampling(e) {
    return Request.put(ma("sampling/water/".concat(e.waterSamplingGuid)), e);
  },
  getWaterSamples: function getWaterSamples(e) {
    var t = new QueryString();
    return t.append("NonFieldFeatureGuid", e), Request.get(ma("sampling/water", t.toString()));
  },
  getWaterSamplingItem: function getWaterSamplingItem(e) {
    return Request.get(ma("sampling/water/".concat(e)));
  },
  deleteWaterSamplingItem: function deleteWaterSamplingItem(e) {
    return Request.delete(ma("sampling/water/".concat(e)), null);
  },
  deactivateWaterSamplingItem: function deactivateWaterSamplingItem(e) {
    var t = {
      active: !1,
      waterSamplingGuid: e
    };
    return Request.patch(ma("sampling/water/active", null), t, "application/json", null);
  }
});

var Ga = "http://json-schema.org/draft-04/schema#",
    Ra = {
  IRec: {
    properties: {
      applicationMethodGuid: {
        type: "string"
      },
      applicationTimingGuid: {
        type: "string"
      },
      cropGuid: {
        type: ["null", "string"]
      },
      cropPlantingDate: {
        type: ["null", "string"]
      },
      cropPurposeGuid: {
        type: ["null", "string"]
      },
      equationFilters: {
        anyOf: [{
          $ref: "#/definitions/IRecEquationFilter"
        }, {
          type: "null"
        }]
      },
      equationGroupGuid: {
        type: ["null", "string"]
      },
      equationParameters: {
        anyOf: [{
          items: {
            $ref: "#/definitions/IRecEquationParameter"
          },
          type: "array"
        }, {
          type: "null"
        }]
      },
      recAreaGuid: {
        type: ["null", "string"]
      },
      recGuid: {
        type: ["null", "string"]
      },
      recNutrientList: {
        anyOf: [{
          items: {
            $ref: "#/definitions/IRecNutrient"
          },
          type: "array"
        }, {
          type: "null"
        }]
      },
      recPlanting: {
        anyOf: [{
          $ref: "#/definitions/IRecPlanting"
        }, {
          type: "null"
        }]
      },
      productMixList: {
        anyOf: [{
          items: {
            $ref: "#/definitions/IRecProductMix"
          },
          type: "array"
        }, {
          type: "null"
        }]
      },
      recStatus: {
        type: ["null", "string"]
      },
      releasedYn: {
        type: "boolean"
      },
      varietyHybridGuid: {
        type: ["null", "string"]
      },
      yieldGoal: {
        type: ["null", "string"]
      },
      yieldGoalUnitGuid: {
        type: ["null", "string"]
      }
    },
    required: ["applicationMethodGuid", "applicationTimingGuid", "cropGuid", "cropPlantingDate", "cropPurposeGuid", "equationFilters", "equationGroupGuid", "equationParameters", "recAreaGuid", "recGuid", "recNutrientList", "recPlanting", "productMixList", "recStatus", "releasedYn", "varietyHybridGuid", "yieldGoal", "yieldGoalUnitGuid"],
    type: "object"
  },
  IRecArea: {
    properties: {
      applyRecToArea: {
        type: "boolean"
      },
      fieldBoundaryGuid: {
        type: ["null", "string"]
      },
      zonePolygons: {
        items: {
          $ref: "#/definitions/IZonePolygon"
        },
        type: "array"
      },
      recAreaClassBreak: {},
      recAreaGuid: {
        type: ["null", "string"]
      },
      recAreaId: {
        type: "number"
      },
      recGeneralGuid: {
        type: ["null", "string"]
      },
      calculatedArea: {
        type: "number"
      },
      recs: {
        items: {
          $ref: "#/definitions/IRec"
        },
        type: "array"
      }
    },
    required: ["applyRecToArea", "zonePolygons", "recAreaClassBreak", "recAreaGuid", "recAreaId", "recGeneralGuid", "calculatedArea", "recs"],
    type: "object"
  },
  IZonePolygon: {
    properties: {
      polygonGuid: {
        type: ["null", "string"]
      },
      shape: {
        type: ["null", "string"]
      }
    },
    required: ["polygonGuid", "shape"],
    type: "object"
  },
  IRecEquationFilter: {
    properties: {
      activeEquationGroupGuid: {
        type: ["null", "string"]
      },
      applicationMethodGuid: {
        type: ["null", "string"]
      },
      applicationTimingGuid: {
        type: ["null", "string"]
      },
      buildFactorGuid: {
        type: ["null", "string"]
      },
      cropClassNameGuid: {
        type: ["null", "string"]
      },
      cropGuid: {
        type: ["null", "string"]
      },
      cropPurposeGuid: {
        type: ["null", "string"]
      },
      incorporationDepthGuid: {
        type: ["null", "string"]
      },
      nextCropGuid: {
        type: ["null", "string"]
      },
      previousCropGuid: {
        type: ["null", "string"]
      },
      productGuid: {
        type: ["null", "string"]
      },
      recEquationFilterGuid: {
        type: ["null", "string"]
      },
      recGuid: {
        type: ["null", "string"]
      },
      recOptionGuid: {
        type: ["null", "string"]
      },
      soilTextureGuid: {
        type: ["null", "string"]
      },
      targetpHGuid: {
        type: ["null", "string"]
      },
      tillageMethodGuid: {
        type: ["null", "string"]
      }
    },
    required: ["activeEquationGroupGuid", "applicationMethodGuid", "applicationTimingGuid", "buildFactorGuid", "cropClassNameGuid", "cropGuid", "cropPurposeGuid", "incorporationDepthGuid", "nextCropGuid", "previousCropGuid", "productGuid", "recEquationFilterGuid", "recGuid", "recOptionGuid", "soilTextureGuid", "targetpHGuid", "tillageMethodGuid"],
    type: "object"
  },
  IRecEquationParameter: {
    properties: {
      analysisLayerGuid: {
        type: ["null", "string"]
      },
      dataType: {
        type: ["null", "string"]
      },
      dataTypeGuid: {
        type: ["null", "string"]
      },
      equationParameterGuid: {
        type: ["null", "string"]
      },
      equationParameterValueGuid: {
        type: ["null", "string"]
      },
      label: {
        type: ["null", "string"]
      },
      managementAreaLayerGuids: {
        anyOf: [{
          type: "null"
        }, {
          type: "array",
          items: {
            type: "string"
          }
        }]
      },
      name: {
        type: ["null", "string"]
      },
      recGuid: {
        type: ["null", "string"]
      },
      value: {
        type: ["null", "string"]
      }
    },
    required: ["analysisLayerGuid", "dataType", "dataTypeGuid", "equationParameterGuid", "equationParameterValueGuid", "label", "name", "recGuid", "value"],
    type: "object"
  },
  IRecNutrient: {
    properties: {
      averageAdjustedRecNutrientResult: {
        $ref: "#/definitions/IRecNutrientResult"
      },
      averageCreditRecNutrientResult: {
        $ref: "#/definitions/IRecNutrientResult"
      },
      averageRecNutrientResult: {
        $ref: "#/definitions/IRecNutrientResult"
      },
      cost: {
        type: ["null", "string"]
      },
      costUnitGuid: {
        type: ["null", "string"]
      },
      creditedGridCells: {
        anyOf: [{
          items: {},
          type: "array"
        }, {
          type: "null"
        }]
      },
      credits: {
        anyOf: [{
          items: {},
          type: "array"
        }, {
          type: "null"
        }]
      },
      equationGuid: {
        type: ["null", "string"]
      },
      equationName: {
        type: ["null", "string"]
      },
      equationSuccess: {
        type: "boolean"
      },
      exportYn: {
        type: "boolean"
      },
      missingEquationAttributes: {
        anyOf: [{
          items: {},
          type: "array"
        }, {
          type: "null"
        }]
      },
      nutrientGuid: {
        type: ["null", "string"]
      },
      nutrientName: {
        type: ["null", "string"]
      },
      productBlendGuid: {
        type: ["null", "string"]
      },
      recGuid: {
        type: ["null", "string"]
      },
      recNutrientGuid: {
        type: ["null", "string"]
      },
      recNutrientParameters: {
        $ref: "#/definitions/IRecNutrientParameters"
      },
      recNutrientProductMix: {
        $ref: "#/definitions/IRecNutrientProductMix"
      },
      unitGuid: {
        type: ["null", "string"]
      },
      unitName: {
        type: ["null", "string"]
      }
    },
    required: ["averageAdjustedRecNutrientResult", "averageCreditRecNutrientResult", "averageRecNutrientResult", "cost", "costUnitGuid", "creditedGridCells", "credits", "equationGuid", "equationName", "equationSuccess", "exportYn", "missingEquationAttributes", "nutrientGuid", "nutrientName", "productBlendGuid", "recGuid", "recNutrientGuid", "recNutrientParameters", "recNutrientProductMix", "unitGuid", "unitName"],
    type: "object"
  },
  IRecNutrientResult: {
    properties: {
      area: {
        type: ["null", "string"]
      },
      maxRate: {
        type: ["null", "string"]
      },
      minRate: {
        type: ["null", "string"]
      },
      nutrientRate: {
        type: ["null", "string"]
      },
      percentAdjustment: {
        type: ["null", "string"]
      },
      pricePerAcre: {
        type: ["null", "string"]
      },
      productRate: {
        type: ["null", "string"]
      },
      recNutrientGuid: {
        type: ["null", "string"]
      },
      totalProduct: {
        type: ["null", "string"]
      },
      appliedNutrientRate: {
        type: ["null", "string"]
      },
      appliedProductRate: {
        type: ["null", "string"]
      },
      appliedArea: {
        type: ["null", "string"]
      }
    },
    required: ["area", "maxRate", "minRate", "nutrientRate", "percentAdjustment", "pricePerAcre", "productRate", "recNutrientGuid", "totalProduct", "appliedNutrientRate", "appliedProductRate", "appliedArea"],
    type: "object"
  },
  IRecNutrientNutrient: {
    properties: {
      nutrientGuid: {
        type: ["null", "string"]
      },
      nutrientPercent: {
        type: ["null", "string"]
      },
      recNutrientProductMixGuid: {
        type: ["null", "string"]
      }
    },
    required: ["nutrientGuid", "nutrientPercent", "recNutrientProductMixGuid"],
    type: "object"
  },
  IRecNutrientParameters: {
    properties: {
      averageRate: {
        type: ["null", "string"]
      },
      carrierVolume: {
        type: ["null", "string"]
      },
      maximumRate: {
        type: ["null", "string"]
      },
      minimumExcludeZeros: {
        type: "boolean"
      },
      minimumIncludeZeros: {
        type: "boolean"
      },
      minimumRate: {
        type: ["null", "string"]
      },
      percentAdjustment: {
        type: ["null", "string"]
      },
      pricePerAcre: {
        type: ["null", "string"]
      },
      recNutrientGuid: {
        type: ["null", "string"]
      },
      recNutrientParametersGuid: {
        type: ["null", "string"]
      },
      switchRate: {
        type: ["null", "string"]
      },
      totalProduct: {
        type: ["null", "string"]
      },
      zerosBelowMinimum: {
        type: "boolean"
      },
      zerosBelowSwitchRate: {
        type: "boolean"
      }
    },
    required: ["averageRate", "carrierVolume", "maximumRate", "minimumExcludeZeros", "minimumIncludeZeros", "minimumRate", "percentAdjustment", "pricePerAcre", "recNutrientGuid", "recNutrientParametersGuid", "switchRate", "totalProduct", "zerosBelowMinimum", "zerosBelowSwitchRate"],
    type: "object"
  },
  IRecNutrientProduct: {
    properties: {
      cost: {
        type: ["null", "string"]
      },
      costUnitGuid: {
        type: ["null", "string"]
      },
      customProductGuid: {
        type: ["null", "string"]
      },
      customProductName: {
        type: ["null", "string"]
      },
      percentOfMix: {
        type: ["null", "string"]
      },
      productGuid: {
        type: ["null", "string"]
      },
      productName: {
        type: ["null", "string"]
      },
      rate: {
        type: ["null", "string"]
      },
      rateUnitGuid: {
        type: ["null", "string"]
      },
      recNutrientProductMixGuid: {
        type: ["null", "string"]
      }
    },
    required: ["cost", "costUnitGuid", "customProductGuid", "customProductName", "percentOfMix", "productGuid", "productName", "rate", "rateUnitGuid", "recNutrientProductMixGuid"],
    type: "object"
  },
  IRecNutrientProductMix: {
    properties: {
      density: {
        type: ["null", "string"]
      },
      densityUnitGuid: {
        type: ["null", "string"]
      },
      guaranteedAnalysis: {
        type: ["null", "string"]
      },
      limeEfficiency: {
        type: ["null", "string"]
      },
      name: {
        type: ["null", "string"]
      },
      nutrients: {
        anyOf: [{
          items: {
            $ref: "#/definitions/IRecNutrientNutrient"
          },
          type: "array"
        }, {
          type: "null"
        }]
      },
      physicalStateGuid: {
        type: ["null", "string"]
      },
      productMixType: {
        type: ["null", "string"]
      },
      productMixTypeGuid: {
        type: ["null", "string"]
      },
      products: {
        anyOf: [{
          items: {
            $ref: "#/definitions/IRecNutrientProduct"
          },
          type: "array"
        }, {
          type: "null"
        }]
      },
      recNutrientProductMixGuid: {
        type: ["null", "string"]
      },
      targetRate: {
        type: ["null", "string"]
      },
      targetRateUnit: {
        type: ["null", "string"]
      },
      targetRateUnitGuid: {
        type: ["null", "string"]
      }
    },
    required: ["density", "densityUnitGuid", "guaranteedAnalysis", "limeEfficiency", "name", "nutrients", "physicalStateGuid", "productMixType", "productMixTypeGuid", "products", "recNutrientProductMixGuid", "targetRate", "targetRateUnit", "targetRateUnitGuid"],
    type: "object"
  },
  IRecPlanting: {
    properties: {
      cropAgeIaGuid: {
        type: ["null", "string"]
      },
      cropAgeWhenPlanted: {
        type: ["null", "string"]
      },
      cropClassNameGuid: {
        type: ["null", "string"]
      },
      cropGuid: {
        type: ["null", "string"]
      },
      cropName: {
        type: ["null", "string"]
      },
      cropPurposeGuid: {
        type: ["null", "string"]
      },
      cropPurposeName: {
        type: ["null", "string"]
      },
      isImportedYn: {
        type: "boolean"
      },
      plantSpacing: {
        type: ["null", "string"]
      },
      plantSpacingIaGuid: {
        type: ["null", "string"]
      },
      plantingDepth: {
        type: ["null", "string"]
      },
      plantingDepthIaGuid: {
        type: ["null", "string"]
      },
      plantingPatternGuid: {
        type: ["null", "string"]
      },
      recGuid: {
        type: ["null", "string"]
      },
      recPlantingVarietyHybridList: {
        anyOf: [{
          items: {},
          type: "array"
        }, {
          type: "null"
        }]
      },
      rowOrientationGuid: {
        type: ["null", "string"]
      },
      rowSpacing: {
        type: ["null", "string"]
      },
      rowSpacingIaGuid: {
        type: ["null", "string"]
      },
      transplantTypeGuid: {
        type: ["null", "string"]
      },
      transplantYn: {
        type: "boolean"
      }
    },
    required: ["cropAgeIaGuid", "cropAgeWhenPlanted", "cropClassNameGuid", "cropGuid", "cropName", "cropPurposeGuid", "cropPurposeName", "isImportedYn", "plantSpacing", "plantSpacingIaGuid", "plantingDepth", "plantingDepthIaGuid", "plantingPatternGuid", "recGuid", "recPlantingVarietyHybridList", "rowOrientationGuid", "rowSpacing", "rowSpacingIaGuid", "transplantTypeGuid", "transplantYn"],
    type: "object"
  },
  IRecProductMix: {
    properties: {
      name: {
        type: ["null", "string"]
      },
      productMixId: {
        type: ["null", "string"]
      },
      productMixType: {
        type: ["null", "string"]
      },
      productMixTypeGuid: {
        type: ["null", "string"]
      },
      products: {
        items: {
          $ref: "#/definitions/IRecProductMixProduct"
        },
        type: "array"
      },
      recGuid: {
        type: ["null", "string"]
      },
      recProductMixGuid: {
        type: ["null", "string"]
      }
    },
    required: ["name", "productMixId", "productMixType", "productMixTypeGuid", "products", "recGuid", "recProductMixGuid"],
    type: "object"
  },
  IRecProductMixProduct: {
    properties: {
      cost: {
        type: ["null", "string"]
      },
      costUnitGuid: {
        type: ["null", "string"]
      },
      customProductGuid: {
        type: ["null", "string"]
      },
      customProductName: {
        type: ["null", "string"]
      },
      isCarrier: {
        type: "boolean"
      },
      percentOfMix: {
        type: ["null", "string"]
      },
      productGuid: {
        type: ["null", "string"]
      },
      productName: {
        type: ["null", "string"]
      },
      rate: {
        type: ["null", "string"]
      },
      rateUnit: {
        type: ["null", "string"]
      },
      rateUnitGuid: {
        type: ["null", "string"]
      },
      recProductMixGuid: {
        type: ["null", "string"]
      },
      recProductMixProductGuid: {
        type: ["null", "string"]
      }
    },
    required: ["cost", "costUnitGuid", "customProductGuid", "customProductName", "isCarrier", "percentOfMix", "productGuid", "productName", "rate", "rateUnit", "rateUnitGuid", "recProductMixGuid", "recProductMixProductGuid"],
    type: "object"
  }
},
    Ea = {
  brandOrganizationGuid: {
    type: ["null", "string"]
  },
  recDate: {
    type: ["null", "string"]
  },
  cropClassNameGuid: {
    type: ["null", "string"]
  },
  cropGuid: {
    type: ["null", "string"]
  },
  cropPlantingDate: {
    type: ["null", "string"]
  },
  cropPurposeGuid: {
    type: ["null", "string"]
  },
  croppingSeasonCycleGuid: {
    type: ["null", "string"]
  },
  croppingSeasonGuid: {
    type: ["null", "string"]
  },
  displayName: {
    type: ["null", "string"]
  },
  failureAttributes: {
    type: ["null", "string"]
  },
  fieldBoundaryGuid: {
    type: ["null", "string"]
  },
  fieldGuid: {
    type: ["null", "string"]
  },
  customerGuid: {
    type: ["null", "string"]
  },
  isClassified: {
    type: "boolean"
  },
  missingAttributes: {
    type: ["null", "string"]
  },
  name: {
    type: ["null", "string"]
  },
  notes: {
    type: ["null", "string"]
  },
  personList: {
    items: {},
    type: "array"
  },
  planName: {
    type: ["null", "string"]
  },
  recAreaList: {
    items: {
      $ref: "#/definitions/IRecArea"
    },
    type: "array"
  },
  recGeneralGuid: {
    type: ["null", "string"]
  },
  recStatuses: {
    type: ["null", "string"]
  },
  recType: {
    type: ["null", "string"]
  },
  recTypeGuid: {
    type: ["null", "string"]
  },
  surfaceRendererVectorGuid: {
    type: ["null", "string"]
  },
  varietyHybridGuid: {
    type: ["null", "string"]
  }
},
    Sa = ["brandOrganizationGuid", "recDate", "cropClassNameGuid", "cropGuid", "cropPlantingDate", "cropPurposeGuid", "croppingSeasonCycleGuid", "croppingSeasonGuid", "displayName", "failureAttributes", "fieldBoundaryGuid", "fieldGuid", "isClassified", "missingAttributes", "name", "notes", "personList", "planName", "recAreaList", "recGeneralGuid", "recStatuses", "recType", "recTypeGuid", "surfaceRendererVectorGuid", "varietyHybridGuid"];
var Ta = {
  $schema: Ga,
  definitions: Ra,
  properties: Ea,
  required: Sa,
  type: "object"
},
    Aa = Object.freeze({
  __proto__: null,
  $schema: Ga,
  definitions: Ra,
  properties: Ea,
  required: Sa,
  type: "object",
  default: Ta
});
var _a = "http://json-schema.org/draft-04/schema#",
    La = {
  properties: {
    activeYn: {
      type: "boolean"
    },
    recDate: {
      type: "string"
    },
    cropGuids: {
      type: "array"
    },
    cropDisplayName: {
      type: ["null", "string"]
    },
    croppingSeasonGuid: {
      type: "string"
    },
    croppingSeasonName: {
      type: "string"
    },
    fieldGuid: {
      type: "string"
    },
    importedStatus: {
      type: "number"
    },
    modifiedDate: {
      type: "string"
    },
    modifiedBy: {
      type: "string"
    },
    recDisplayName: {
      type: "string"
    },
    recGeneralGuid: {
      type: "string"
    },
    recGuids: {
      items: {
        type: "string"
      },
      type: "array"
    },
    recName: {
      type: ["string", "null"]
    },
    recStatuses: {
      type: "string"
    },
    recType: {
      type: "string"
    },
    recTypeGuid: {
      type: "string"
    }
  },
  required: ["activeYn", "recDate", "cropDisplayName", "cropGuids", "croppingSeasonGuid", "croppingSeasonName", "fieldGuid", "importedStatus", "modifiedDate", "modifiedBy", "recDisplayName", "recGeneralGuid", "recGuids", "recName", "recStatuses", "recType", "recTypeGuid"],
  type: "object"
};
var fa = {
  $schema: _a,
  items: La,
  type: "array"
},
    Ua = Object.freeze({
  __proto__: null,
  $schema: _a,
  items: La,
  type: "array",
  default: fa
}),
    Pa = aggregateUrlGenerator("rec", "v1.0"),
    Ia = aggregateUrlGenerator("agbytes/nutrient", "v1.0");
D.addSchema(Aa, "recdetails");
D.addSchema(Ua, "recsummary");

var getRec = function getRec(e, t) {
  return Request.get(Pa(t)).then(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      recAreaList: e.zones.map(function (e) {
        return {
          recAreaGuid: e.zoneGuid,
          recAreaId: e.id,
          recGeneralGuid: e.generalGuid,
          applyRecToArea: e.applyToArea,
          calculatedArea: e.calculatedArea,
          fieldBoundaryGuid: e.fieldBoundaryGuid,
          recAreaClassBreak: e.classBreak,
          recs: e.details,
          zonePolygons: e.polygons.map(function (e) {
            return _objectSpread(_objectSpread({}, e), {}, {
              shape: null
            });
          })
        };
      })
    });
  });
},
    va = aggregateUrlGenerator("agbytes/unit", "v1.0");

window.getRec = getRec;
var ha = Object.freeze({
  __proto__: null,
  IRecDetailsSchemaKey: "recdetails",
  SummarySchemaKey: "recsummary",
  addCustomProduct: function addCustomProduct(e, t) {
    return Request.post(apiUrl("Recommendations/AddCustomProduct"), {
      UserGuid: e,
      Model: t
    }, void 0, void 0, !1);
  },
  addDefaultProduct: function addDefaultProduct(e, t) {
    return Request.post(apiUrl("Recommendations/AddDefaultProduct"), {
      UserGuid: e,
      Model: t
    });
  },
  addProductBlend: function addProductBlend(e, t) {
    return Request.post(apiUrl("Recommendations/AddProductBlend"), {
      UserGuid: e,
      Model: t
    }, void 0, void 0, !1);
  },
  addBatchRecAdjustments: function addBatchRecAdjustments(e, t) {
    return Request.post(apiUrl("Recommendations/AddBatchRecAdjustments"), {
      UserGuid: e,
      Model: t
    });
  },
  addRecAdjustments: function addRecAdjustments(e, t) {
    return Request.post(apiUrl("Recommendations/AddRecAdjustments"), {
      UserGuid: e,
      Model: t
    });
  },
  addRecCredit: function addRecCredit(e, t) {
    return Request.post(apiUrl("Recommendations/AddRecCredit"), {
      UserGuid: e,
      Model: t
    });
  },
  addUpdateRecProduct: function addUpdateRecProduct(e, t) {
    return Request.post(apiUrl("Recommendations/AddUpdateRecProduct"), {
      UserGuid: e,
      Model: t
    });
  },
  addRecs: function addRecs(e, t) {
    return Request.post(apiUrl("Recommendations/AddRecs"), {
      UserGuid: e,
      Model: t
    });
  },
  addRecsWithEquationRun: function addRecsWithEquationRun(e, t) {
    return Request.post(apiUrl("Recommendations/AddRecsWithEquationRun"), {
      UserGuid: e,
      Model: t
    });
  },
  validRecGeneral: function validRecGeneral(e, t) {
    return Request.post(apiUrl("Recommendations/ValidRecGeneral"), {
      UserGuid: e,
      Model: t
    });
  },
  validateEquationRecs: function validateEquationRecs(e, t) {
    return Request.post(apiUrl("Recommendations/ValidateEquationRecs"), {
      UserGuid: e,
      Model: t
    });
  },
  activateRec: function activateRec(e, t) {
    return Request.post(apiUrl("Recommendations/ActivateRec"), {
      UserGuid: e,
      Model: t
    });
  },
  cancelRec: function cancelRec(e, t) {
    return Request.post(apiUrl("Recommendations/CancelRec"), {
      UserGuid: e,
      Model: t
    });
  },
  deactivateProductBlend: function deactivateProductBlend(e, t) {
    return Request.post(apiUrl("Recommendations/DeactivateProductBlend"), {
      UserGuid: e,
      Model: t
    });
  },
  deleteRecs: function deleteRecs(e, t) {
    return Request.post(apiUrl("Recommendations/DeleteRecs"), {
      UserGuid: e,
      Model: t
    });
  },
  deleteRecCredit: function deleteRecCredit(e, t) {
    return Request.post(apiUrl("Recommendations/DeleteRecCredit"), {
      UserGuid: e,
      Model: t
    });
  },
  getAvailableProducts: function getAvailableProducts(e, t) {
    return Request.post(apiUrl("Recommendations/GetAvailableProducts"), {
      UserGuid: e,
      Model: t
    });
  },
  getCreditedGridCells: function getCreditedGridCells(e, t) {
    return Request.post(apiUrl("Recommendations/GetCreditedGridCells"), {
      UserGuid: e,
      Model: t
    });
  },
  getCustomProducts: function getCustomProducts(e, t) {
    return Request.post(apiUrl("Recommendations/GetCustomProducts"), {
      UserGuid: e,
      Model: t
    });
  },
  getCustomProductTypes: function getCustomProductTypes(e) {
    return Request.post(apiUrl("Recommendations/GetCustomProductTypes"), {
      UserGuid: e
    });
  },
  getDefaultCarrier: function getDefaultCarrier(e) {
    return Request.post(apiUrl("Recommendations/GetDefaultCarrier"), {
      UserGuid: e
    });
  },
  getEquationGroups: function getEquationGroups(e, t) {
    return Request.post(apiUrl("Recommendations/GetEquationGroups"), {
      UserGuid: e,
      Model: t
    });
  },
  getFertilizerBlendsByNutrient: function getFertilizerBlendsByNutrient(e, t) {
    return Request.post(apiUrl("Recommendations/GetFertilizerBlendsByNutrient"), {
      UserGuid: e,
      Model: t
    });
  },
  getNutrients: function () {
    var _getNutrients = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
      var t, r;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              t = {
                "user-guid": e
              }, r = new QueryString();
              r.append("PageSize", "2147483647");
              _context11.next = 4;
              return Request.get(Ia("list", r.toString()), null, null, t);

            case 4:
              return _context11.abrupt("return", _context11.sent.data);

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function getNutrients(_x22) {
      return _getNutrients.apply(this, arguments);
    }

    return getNutrients;
  }(),
  getProductBlends: function getProductBlends(e, t) {
    return Request.post(apiUrl("Recommendations/GetProductBlends"), {
      UserGuid: e,
      Model: t
    });
  },
  getProductMixTypes: function getProductMixTypes(e) {
    return Request.post(apiUrl("Recommendations/GetProductMixTypes"), {
      UserGuid: e
    });
  },
  getRec: getRec,
  fetchSummaries: function () {
    var _fetchSummaries2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
      var t, r;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              t = {
                field: e
              };
              _context12.next = 3;
              return Request.post(Pa("summary"), t, "application/json");

            case 3:
              r = _context12.sent;
              _context12.next = 6;
              return validateResults(Promise.resolve(r), D.getSchema("recsummary"));

            case 6:
              return _context12.abrupt("return", _context12.sent);

            case 7:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function fetchSummaries(_x23) {
      return _fetchSummaries2.apply(this, arguments);
    }

    return fetchSummaries;
  }(),
  getRecSurfaceSymbology: function getRecSurfaceSymbology(e, t) {
    return Request.post(apiUrl("Layers/GetRecSurfaceSymbology"), {
      UserGuid: e,
      Model: t
    });
  },
  getRecTypes: function getRecTypes() {
    return Request.get(Pa("type"));
  },
  getPastZones: function getPastZones(e) {
    var t = new QueryString();
    return t.append("FieldBoundaryGuid", e), Request.get(Pa("pastZone", t.toString()));
  },
  updateRecs: function updateRecs(e, t) {
    return Request.post(apiUrl("Recommendations/UpdateRecs"), {
      UserGuid: e,
      Model: t
    });
  },
  updateRecsWithEquationRun: function updateRecsWithEquationRun(e, t) {
    return Request.post(apiUrl("Recommendations/UpdateRecsWithEquationRun"), {
      UserGuid: e,
      Model: t
    });
  },
  updateCustomProduct: function updateCustomProduct(e, t) {
    return Request.post(apiUrl("Recommendations/UpdateCustomProduct"), {
      UserGuid: e,
      Model: t
    });
  },
  updateProductBlend: function updateProductBlend(e, t) {
    return Request.post(apiUrl("Recommendations/UpdateProductBlend"), {
      UserGuid: e,
      Model: t
    });
  },
  updateUserEquationPreferences: function updateUserEquationPreferences(e, t) {
    return Request.post(apiUrl("Recommendations/UpdateUserEquationPreferences"), {
      UserGuid: e,
      Model: t
    });
  },
  getFilteredEquationGroups: function getFilteredEquationGroups(e, t) {
    return Request.post(apiUrl("Recommendations/GetFilteredEquationGroups"), {
      UserGuid: e,
      Model: t
    });
  },
  getCropClassNameListByFilteredEquationGroup: function getCropClassNameListByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetCropClassNameListByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getCropListByFilteredEquationGroup: function getCropListByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetCropListByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getNextCropListByFilteredEquationGroup: function getNextCropListByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetNextCropListByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getManagementAreaLayersByFilteredEquationGroup: function getManagementAreaLayersByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetManagementAreaLayersByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getNormalizedYieldLayersByFilteredEquationGroup: function getNormalizedYieldLayersByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetNormalizedYieldLayersByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklistByIdAndFilteredEquationGroup: function getPicklistByIdAndFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetPicklistByIdAndFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getPreviousCropListByFilteredEquationGroup: function getPreviousCropListByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetPreviousCropListByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getProductListByFilteredEquationGroup: function getProductListByFilteredEquationGroup(e, t) {
    return Request.post(apiUrl("Recommendations/GetProductListByFilteredEquationGroup"), {
      UserGuid: e,
      Model: t
    });
  },
  getRecConversionFactors: function () {
    var _getRecConversionFactors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e) {
      var t, r, i, s;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              t = {
                "user-guid": e
              }, r = new QueryString();
              r.append("PageSize", "2147483647");
              _context13.next = 4;
              return Request.get(va("list", r.toString()), null, null, t);

            case 4:
              i = _context13.sent;
              s = S.clone({
                precision: 10,
                rounding: 0
              });
              return _context13.abrupt("return", ["Volume", "Weight"].map(function (e) {
                var t = i.data.filter(function (t) {
                  return t.type === e;
                });
                return t.map(function (e) {
                  return t.filter(function (t) {
                    return t !== e;
                  }).map(function (t) {
                    return {
                      name: "".concat(e.abbreviation.replace(" ", "")).concat(t.abbreviation.replace(" ", "")),
                      factor: new s(e.conversionFactor).div(new s(t.conversionFactor)).toNumber()
                    };
                  });
                }).flat();
              }).flat());

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function getRecConversionFactors(_x24) {
      return _getRecConversionFactors.apply(this, arguments);
    }

    return getRecConversionFactors;
  }()
});
export { APIError as $, er as A, dr as B, Ir as C, Or as D, zr as E, Ei as F, _i as G, fi as H, xi as I, Qi as J, ds as K, ce as L, Es as M, Us as N, Os as O, Bs as P, QueryString as Q, Request as R, We as S, js as T, Js as U, ra as V, ws as W, ga as X, ha as Y, C as Z, M as _, apiUrl as a, APIErrorInvalidSchema as a0, APIErrorWithCode as a1, APICommandFailed as a2, D as a3, validateResults as a4, getAuthorizationHeader as a5, T as a6, L as a7, fetchExtent as a8, st as a9, zoneToGraphic as aA, qt as aB, getValidEventIds as aC, ea as aD, xs as aE, getColorRamp as aF, ta as aG, Ys as aH, at as aa, importFieldBoundaryToGraphic as ab, fetchFieldBoundaryGuids as ac, fetchFieldBoundariesByBoundaryGuid as ad, fieldBoundaryToGraphic as ae, fetchFieldBoundariesByCurrentUserGuidAndExtent as af, fetchFieldBoundariesByFieldGuid as ag, ks as ah, Qs as ai, Ws as aj, sampleSiteToGraphic as ak, Zs as al, sampleSiteSequenceToGraphic as am, getCoverageSurfaceMapImage as an, fetchSurfacePolygons as ao, surfacePolygonToGraphic as ap, getSurfaceEventLayerPoints as aq, Nt as ar, fetchFieldBoundariesByCustomerGuid as as, getFieldBoundaryCentroids as at, getFilterPointDataFromS3 as au, getImportDataFromS3 as av, rt as aw, ya as ax, zs as ay, fetchZones as az, aggregateUrlGenerator as b, gi as c, F as d, urlJoin as e, j as f, $ as g, W as h, Z as i, ae as j, ge as k, Te as l, it as m, newApiUrl as n, Me as o, pdfUrl as p, $e as q, nt as r, dt as s, ct as t, I as u, vt as v, Ot as w, Mt as x, Bt as y, Yt as z };